<template>
  <!-- 在线季度分析报告 -->
  <div class="analysisReport">
    <el-button type="primary" class="export" @click="exportPdf">导出pdf</el-button>

    <div class="analysisReport_box" ref="pdfContent">
      <div class="bgc">
        <div class="bgcText">
          <h1>职业教育“{{ header.zykName }}”专业大数据季度分析报告</h1>
          <h2>（{{ yearMonthText }}）</h2>
        </div>
        <p />
      </div>
      <div class="chart_box page-box" style="padding-top: 50px">
        <span v-show="false">这是completeNum的值：{{ completeNum }}</span>
        <input id="completeNum" v-model="completeNum" v-show="false" />
        <div class="division">1. 专业基本信息</div>
        <div class="lineheight">
          <div class="table_box">
            <div class="table">
              <template v-for="(item, index) in list">
                <div class="tr" :key="index">
                  <div class="td" v-for="(td, index1) in item.td1" :key="index1">
                    {{ td }}
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>

      <div class="chart_box page-box">
        <div class="division">2. 本专业国家级资源库（{{ $route.query.zykNum }}）运行数据分析</div>
        <div class="number_time2" style="margin-top: 1.875rem">
          <div>
            <span class="shchool">{{ allHostUnit }}</span>
            <span class="time">时间：{{ $route.query.startDay }} 至 {{ $route.query.endDay }}</span>
          </div>
          <p />
          <p />
        </div>
        <h4>2.1 当前资源库总体情况</h4>
        <h5>2.1.1 当前资源库用户情况</h5>
        <p>
          当前该资源库的用户总数{{ dataHandler(resourceLibrary.total) }}人，其中学生{{
            dataHandler(resourceLibrary.studentNum)
          }}人；教师{{ dataHandler(resourceLibrary.teacherNum) }}人；社会学习者{{
            dataHandler(resourceLibrary.socialNum)
          }}人；企业用户{{ dataHandler(resourceLibrary.enterpriseNum) }}人。具体如图1所示。
        </p>
        <div class="standards_content echartsHeight">
          <circularChart
            :refId="'resourceLibraryChart'"
            :isShowTextColor="true"
            :datas="resourceLibrary.dataList"
            :colorName="1"
            :innerText="'数量'"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :legendLeft="'60%'"
            :circleSize="80"
            :legendListFontSize="30"
          />
        </div>
        <div class="chart_name">图1 资源库注册用户类型分布总体情况</div>
        <h5 style="margin-top: 150px">2.1.2 当前资源库建设单位注册用户情况</h5>
        <p>
          当前该资源库建设单位教师用户{{
            dataHandler(userCountUnit.teacherNum)
          }}人，其中主持单位的教师用户{{
            dataHandler(userCountUnit.zcteacherNum)
          }}人，参建单位的教师用户{{
            dataHandler(userCountUnit.cjteacherNum)
          }}人；建设单位学生用户{{
            dataHandler(userCountUnit.studentNum)
          }}人，其中主持单位的学生用户{{
            dataHandler(userCountUnit.zcstudentNum)
          }}人，参建单位的学生用户{{ dataHandler(userCountUnit.cjstudentNum) }}人。具体如图2所示。
        </p>
        <div class="standards_content echartsHeight">
          <circularChart
            :refId="'resourceLibraryChart'"
            :isShowTextColor="true"
            :datas="userCountUnit.teacherList"
            :colorName="1"
            :innerText="'数量'"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :legendLeft="'55%'"
            :circleSize="80"
            :legendListFontSize="30"
          />
        </div>
        <div class="standards_content echartsHeight">
          <circularChart
            :refId="'resourceLibraryChart'"
            :isShowTextColor="true"
            :datas="userCountUnit.studentList"
            :colorName="1"
            :innerText="'数量'"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :legendLeft="'55%'"
            :circleSize="80"
            :legendListFontSize="30"
          />
        </div>
        <div class="chart_name">图2 当前资源库建设单位注册用户情况</div>
      </div>

      <div class="chart_box page-box">
        <h5>2.1.3 当前资源库资源建设情况</h5>
        <p>
          当前该资源库的素材资源总数{{ dataHandler(typeDistribution.total) }}条，其中文本类{{
            dataHandler(typeDistribution.wbNumber)
          }}条；图形图像类{{ dataHandler(typeDistribution.txtxNumber) }}条；视频类{{
            dataHandler(typeDistribution.spNumber)
          }}条；动画类{{ dataHandler(typeDistribution.dhNumber) }}条；虚拟仿真类{{
            dataHandler(typeDistribution.xnfzNumber)
          }}条；微课类{{ dataHandler(typeDistribution.wkNumber) }}条；音频类{{
            dataHandler(typeDistribution.ypNumber)
          }}条；ppt和富媒体等{{
            dataHandler(
              typeDistribution.pptNumber + typeDistribution.kjNumber + typeDistribution.fmtNumber
            )
          }}条；其他{{ dataHandler(typeDistribution.qtNumber) }}条。具体如图3所示。
        </p>
        <div class="standards_content echartsHeight">
          <circularChart
            :isShowTextColor="true"
            :refId="'typeDistributionChart'"
            :datas="typeDistribution.dataList"
            :colorName="1"
            :innerText="'数量'"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :legendLeft="'50%'"
            :circleSize="80"
            :legendListFontSize="30"
          />
        </div>
        <div class="chart_name">图3 资源库素材资源类型分布</div>
        <h5 style="margin-top: 150px">2.1.4 当前资源库标准化课程建设及应用情况</h5>
        <p>
          当前该资源库建有标准化课程{{
            dataHandler(standardization.courseBzNum)
          }}门，按访问量排名前10名如图4所示。
        </p>
        <div class="standards_content echartsHeight" style="height: calc(100vw / 1080 * 300)">
          <tcolumnarChart
            :refId="'standardizationChart'"
            :isExportTextColor="true"
            :isShowTextColor="true"
            :datas="standardization.dataList"
            :transverseData="standardization.transverseData"
            :colorList="colorList"
            :seriesColor="true"
          >
          </tcolumnarChart
          >·
        </div>
        <div class="chart_name">图4 该资源库标准化课程访问量排名（前10名）</div>
        <div class="notes">
          （注1：标准化课程指资源库建设团队按照《指南》要求建设和提供的，涵盖课程基本知识点和技能点，能够适应全国同类和相近专业在线教学基本需要的结构化课程。标准化课程的正确性、逻辑性、权威性由资源库建设团队保证。个性化课程指教师在使用资源库过程中，结合自身实际教学需要和学生特点，对标准化课程进行改造、补充、重构后形成的个性化课程。个性化课程的正确性、逻辑性由建课教师自行保障。注2：如标准化课程或个性化课程显示为0，表明该资源库在课程标注上不规范，需要在资源库运行平台中对课程分类重新标注。）
        </div>
      </div>

      <div class="chart_box page-box flex-box">
        <div>
          <h5>2.1.5 当前资源库用户行为类型分布</h5>
          <p>
            该资源库用户行为活动总量为{{ dataHandler(behaviorTypes.total) }}次，其中课程模块{{
              dataHandler(behaviorTypes.courseModule)
            }}次，资源素材模块{{ dataHandler(behaviorTypes.resourceModule) }}次，论坛模块{{
              dataHandler(behaviorTypes.forumModule)
            }}次，作业模块{{ dataHandler(behaviorTypes.taskModule) }}次，考试模块{{
              dataHandler(behaviorTypes.examinationModule)
            }}次，其他模块{{ dataHandler(behaviorTypes.otherModule) }}次。具体如图5所示。
          </p>
          <div class="standards_content echartsHeight">
            <circularChart
              :isShowTextColor="true"
              :refId="'behaviorTypesChart'"
              :datas="behaviorTypes.dataList"
              :colorName="1"
              :innerText="'数量'"
              :titleLeft="'32%'"
              :legendBackgroundColor="true"
              :legendLeft="'55%'"
              :circleSize="80"
              :legendListFontSize="30"
            />
          </div>
          <div class="chart_name">图5 资源库用户行为类型分布</div>
        </div>
        <div>
          <h5 style="margin-top: 100px">2.1.6 资源库无活动数据情况</h5>
          <p>
            该资源库建设单位已实名教师总数{{
              dataHandler(resourcePool.realTeacher)
            }}人，其中无活动教师{{
              dataHandler(resourcePool.countTeacher)
            }}人；建设单位已实名学生总数{{
              dataHandler(resourcePool.realStudent)
            }}人，其中无活动学生{{ dataHandler(resourcePool.countStudent) }}人；资源总数{{
              dataHandler(typeDistribution.total)
            }}条，其中无访问资源{{
              dataHandler(resourcePool.countResource)
            }}条；请继续关注应用情况，监督其深入应用。具体如图6所示。
          </p>
          <div class="speed">
            <el-row>
              <el-col :span="8">
                <div class="right">实名教师中无活动教师占比:</div>
              </el-col>
              <el-col :span="16">
                <el-progress
                  :text-inside="true"
                  :stroke-width="40"
                  :format="teacherFormat"
                  :percentage="waterDrop.teacher"
                  color="#3B86FF"
                />
              </el-col>
              <el-col :span="8">
                <div class="right">实名学生中无活动学生占比:</div>
              </el-col>
              <el-col :span="16">
                <el-progress
                  :text-inside="true"
                  :stroke-width="40"
                  :format="studentFormat"
                  :percentage="waterDrop.student"
                  color="#63D0FF"
                />
              </el-col>
              <el-col :span="8">
                <div class="right">无访问资源占比:</div>
              </el-col>
              <el-col :span="16">
                <el-progress
                  :text-inside="true"
                  :stroke-width="40"
                  :format="resourceFormat"
                  :percentage="waterDrop.resource"
                  color="#BBA8FF"
                />
              </el-col>
            </el-row>
          </div>
          <div class="chart_name">图6 资源库无活动数据情况</div>
        </div>
        <div>
          <h4>2.2 本季度资源库新增情况</h4>
          <h5>2.2.1 本季度用户新增情况</h5>
          <p>
            该资源库本季度新增教师用户数{{ dataHandler(usersMonth.teacherNum) }}人，新增学生用户数{{
              dataHandler(usersMonth.studentNum)
            }}人，新增企业用户数{{
              dataHandler(usersMonth.enterpriseNum)
            }}人，新增社会学习者用户数{{ dataHandler(usersMonth.socialNum) }}人。具体如图7所示。
          </p>
          <div class="standards_content echartsHeight">
            <discountChart
              :refId="'usersMonthChart'"
              :isExportTextColor="true"
              :isShowTextColor="true"
              :datas="usersMonth.dataList"
              :transverseData="usersMonth.transverseData"
              :colorList="colorList"
              :legendList="usersMonth.legendList"
              :innerText="'单位：人'"
            >
            </discountChart>
          </div>
          <div class="chart_name">图7 本季度用户新增情况</div>
        </div>
      </div>

      <div class="chart_box page-box">
        <p>
          该资源库本季度新增用户中，主持单位新增教师数{{
            dataHandler(majorUser.teacher)
          }}人，参建单位新增教师数{{ dataHandler(majorUser.cjteacher) }}人，主持单位新增学生数{{
            dataHandler(majorUser.student)
          }}人，参建单位新增学生数{{
            dataHandler(majorUser.cjstudent)
          }}人，主持单位与参建单位新增占比情况具体如图8所示。
        </p>
        <div class="speed">
          <el-row>
            <el-col :span="6">
              <div style="font-size: 1.8125rem">主持单位新增教师占比:</div>
            </el-col>
            <el-col :span="18">
              <el-progress
                :text-inside="true"
                :stroke-width="40"
                :format="majorteacherFormat"
                :percentage="waterDrop.majorteacher"
                color="#3B86FF"
              />
            </el-col>

            <el-col :span="6">
              <div style="font-size: 1.8125rem">参建单位新增教师占比：</div>
            </el-col>
            <el-col :span="18">
              <el-progress
                :text-inside="true"
                :stroke-width="40"
                :format="unitteacherFormat"
                :percentage="waterDrop.unitteacher"
                color="#63D0FF"
              />
            </el-col>

            <el-col :span="6">
              <div style="font-size: 1.8125rem">主持单位新增学生占比：</div>
            </el-col>
            <el-col :span="18">
              <el-progress
                :text-inside="true"
                :stroke-width="40"
                :format="majorstudentFormat"
                :percentage="waterDrop.majorstudent"
                color="#BBA8FF"
              />
            </el-col>

            <el-col :span="6">
              <div style="font-size: 1.8125rem">参建单位学生新增占比：</div>
            </el-col>
            <el-col :span="18">
              <el-progress
                :text-inside="true"
                :stroke-width="40"
                :format="unitstudentFormat"
                :percentage="waterDrop.unitstudent"
                color="#7F88FE"
              />
            </el-col>
          </el-row>
        </div>
        <div class="chart_name">图8 主持单位与参建单位新增用户占比情况</div>
        <h5 style="margin-top: 150px">2.2.2 本季度素材资源新增情况</h5>
        <p>该资源库本季度新增素材资源{{ dataHandler(resourcesMonth.total) }}条。具体如图9所示。</p>
        <div class="standards_content echartsHeight">
          <circularChart
            :isShowTextColor="true"
            :refId="'resourcesMonthChart'"
            :datas="resourcesMonth.dataList"
            :colorName="1"
            :innerText="'数量'"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :legendLeft="'55%'"
            :showValue="true"
            :unit="'个'"
            :circleSize="80"
            :legendListFontSize="30"
          />
        </div>
        <div class="standards_content echartsHeight" style="margin-top: 150px">
          <vcolumnarChart
            :refId="'materialMonthChart'"
            :legendList="materialMonth.legendList"
            :datas="materialMonth.dataList"
            :transverseData="materialMonth.transverseData"
            :colorList="colorList"
            :colorName="1"
            :innerText="'单位：条'"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :circleSize="80"
            :isShowTextColor="true"
            :isExportTextColor="true"
          />
        </div>
        <div class="chart_name">图9 本季度素材资源新增情况</div>
      </div>

      <div class="chart_box page-box flex-box">
        <div>
          <h5>2.2.3 本季度课程新增情况</h5>
          <p>
            本季度标准化课程新增{{ dataHandler(coursesMonth.standardNum) }}门，个性化课程新增{{
              dataHandler(coursesMonth.personalityNum)
            }}门。具体如图10所示。
          </p>
          <div class="standards_content echartsHeight">
            <vcolumnarChart
              :refId="'lastcoursesMonthChart'"
              :legendList="coursesMonth.legendList"
              :datas="coursesMonth.dataList"
              :transverseData="coursesMonth.transverseData"
              :colorList="barColorList"
              :colorName="1"
              :innerText="'单位：门'"
              :titleLeft="'32%'"
              :legendBackgroundColor="true"
              :circleSize="80"
              :isShowTextColor="true"
              :isExportTextColor="true"
            />
          </div>
          <div class="chart_name divorced">图10 本季度课程新增情况</div>
        </div>
        <div>
          <h4>2.3 本季度资源库应用情况</h4>
          <h5>2.3.1 本季度资源访问情况</h5>
          <p>该资源库本季度资源访问{{ dataHandler(accessMonth.total) }}次。具体如图11所示。</p>
          <div class="standards_content echartsHeight">
            <discountChart
              :refId="'accessMonthChart'"
              :isExportTextColor="true"
              :isShowTextColor="true"
              :datas="accessMonth.dataList"
              :transverseData="accessMonth.transverseData"
              :colorList="colorList"
              :legendList="accessMonth.legendList"
              :innerText="'单位：次'"
            >
            </discountChart>
          </div>
          <div class="chart_name">图11 本季度资源访问情况</div>
        </div>
        <div>
          <h5>2.3.2 本季度课程访问情况</h5>
          <p>该资源库本季度课程访问{{ dataHandler(visitsMonth.total) }}次。具体如图12所示。</p>
          <div class="standards_content echartsHeight">
            <discountChart
              :refId="'visitsMonthChart'"
              :isExportTextColor="true"
              :isShowTextColor="true"
              :datas="visitsMonth.dataList"
              :transverseData="visitsMonth.transverseData"
              :colorList="colorList"
              :legendList="visitsMonth.legendList"
              :innerText="'单位：次'"
            >
            </discountChart>
          </div>
          <div class="chart_name">图12 本季度课程访问情况</div>
        </div>
      </div>

      <div class="chart_box page-box">
        <h5>2.3.3 本季度用户访问情况</h5>
        <p>
          该资源库本季度用户访问{{ dataHandler(userAccessMonth.total) }}次。具体访问趋势如图13所示。
        </p>
        <div class="standards_content echartsHeight">
          <discountChart
            :refId="'userAccessMonthChart'"
            :isExportTextColor="true"
            :isShowTextColor="true"
            :datas="userAccessMonth.dataList"
            :transverseData="userAccessMonth.transverseData"
            :colorList="colorList"
            :legendList="userAccessMonth.legendList"
            :innerText="'单位：次'"
          >
          </discountChart>
        </div>
        <div class="chart_name">图13 本季度用户访问情况</div>
        <p style="margin-top: 150px">用户访问时间段分布。具体如图14所示。</p>
        <div class="standards_content echartsHeight">
          <discountChart
            :refId="'behaviorUserChart'"
            :isExportTextColor="true"
            :isShowTextColor="true"
            :datas="behaviorUser.dataList"
            :transverseData="behaviorUser.transverseData"
            :colorList="colorList"
            :legendList="behaviorUser.legendList"
            :innerText="'单位：次'"
          >
          </discountChart>
        </div>
        <div class="chart_name">图14 本季度用户访问时间段分布</div>
      </div>

      <div class="chart_box page-box">
        <h5>2.3.4 本季度访问量较多的教师</h5>
        <div class="chart_name" v-if="tearcherList.dataList.length === 10">
          表1 本季度访问量较多的教师（前10名）
        </div>
        <div class="chart_name" v-else>表1 本季度访问量较多的教师</div>
        <div class="biaoge">
          <table
            border="1"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>姓名</th>
              <th>所属院校</th>
              <th>访问量</th>
            </tr>
            <tr
              v-for="(item, index) in tearcherList.dataList"
              :key="index"
              v-show="tearcherList.dataList.length > 0"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.school }}</td>
              <td>{{ parseInt(item.num) }}</td>
            </tr>
            <tr v-show="tearcherList.dataList.length == 0" class="nothing">
              <td colspan="4">无</td>
            </tr>
          </table>
        </div>
        <h5 style="margin-top: 150px">2.3.5 本季度访问量较多的学生</h5>
        <div class="chart_name" v-if="studentList.dataList.length === 10">
          表2 本季度访问量较多的学生（前10名）
        </div>
        <div class="chart_name" v-else>表2 本季度访问量较多的学生</div>
        <div class="biaoge">
          <table
            border="1"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>姓名</th>
              <th>所属院校</th>
              <th>访问量</th>
            </tr>

            <tr
              v-for="(item, index) in studentList.dataList"
              :key="index"
              v-show="studentList.dataList.length > 0"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.school }}</td>
              <td>{{ parseInt(item.num) }}</td>
            </tr>
            <tr v-show="studentList.dataList.length == 0" class="nothing">
              <td colspan="4">无</td>
            </tr>
          </table>
        </div>
      </div>

      <div class="chart_box page-box">
        <div class="division">3. 本专业市场供需情况分析</div>
        <div class="number_time2" style="margin-top: 1.875rem">
          <div>
            <span class="shchool" />
            <span class="time"
              >数据分析时间：{{ $route.query.startDay }} 至 {{ $route.query.endDay }}</span
            >
          </div>
          <p />
          <p />
        </div>
        <h4>3.1 本专业开设院校办学性质分布</h4>
        <div>
          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 0 &&
              this.getSchool.privateSchoolRankArr.length == 0
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}；暂无民办院校排名。具体如图15所示。
          </p>
          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 0 &&
              this.getSchool.privateSchoolRankArr.length == 1
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}；民办院校数量排名前一的省份为：{{ getSchool.peopleFrist.name }}。具体如图15所示。
          </p>
          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 0 &&
              this.getSchool.privateSchoolRankArr.length == 2
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}；民办院校数量排名前二的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}。具体如图15所示。
          </p>
          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 0 &&
              this.getSchool.privateSchoolRankArr.length == 3
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}。具体如图15所示。
          </p>
          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 0 &&
              this.getSchool.privateSchoolRankArr.length == 4
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}、{{
              getSchool.peopleFourth.name
            }}。具体如图15所示。
          </p>
          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 0 &&
              this.getSchool.privateSchoolRankArr.length == 5
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}、{{ getSchool.peopleFourth.name }}、{{
              getSchool.peoplefive.name
            }}。具体如图15所示。
          </p>
          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 0 &&
              this.getSchool.privateSchoolRankArr.length == 6
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}、{{ getSchool.peopleFourth.name }}、{{
              getSchool.peoplefive.name
            }}、{{ getSchool.peoplesix.name }}。具体如图15所示。
          </p>
          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 0 &&
              this.getSchool.privateSchoolRankArr.length == 7
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}、{{ getSchool.peopleFourth.name }}、{{
              getSchool.peoplefive.name
            }}、{{ getSchool.peoplesix.name }}、{{ getSchool.peopleseven.name }}。具体如图15所示。
          </p>
          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 0 &&
              this.getSchool.privateSchoolRankArr.length == 8
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}、{{ getSchool.peopleFourth.name }}、{{
              getSchool.peoplefive.name
            }}、{{ getSchool.peoplesix.name }}、{{ getSchool.peopleseven.name }}、{{
              getSchool.peopleeight.name
            }}。具体如图15所示。
          </p>
          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 0 &&
              this.getSchool.privateSchoolRankArr.length == 9
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}、{{ getSchool.peopleFourth.name }}、{{
              getSchool.peoplefive.name
            }}、{{ getSchool.peoplesix.name }}、{{ getSchool.peopleseven.name }}、{{
              getSchool.peopleeight.name
            }}、{{ getSchool.peoplenine.name }}。具体如图15所示。
          </p>
          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 0 &&
              this.getSchool.privateSchoolRankArr.length == 10
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}、{{ getSchool.peopleFourth.name }}、{{
              getSchool.peoplefive.name
            }}、{{ getSchool.peoplesix.name }}、{{ getSchool.peopleseven.name }}、{{
              getSchool.peopleeight.name
            }}、{{ getSchool.peoplenine.name }}、{{ getSchool.peopleten.name }}。具体如图15所示。
          </p>
        </div>
        <div>
          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 1 &&
              this.getSchool.privateSchoolRankArr.length == 0
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}；暂无民办院校排名。具体如图15所示。
          </p>
          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 1 &&
              this.getSchool.privateSchoolRankArr.length == 1
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}；民办院校数量排名前一的省份为：{{ getSchool.peopleFrist.name }}。具体如图15所示。
          </p>
          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 1 &&
              this.getSchool.privateSchoolRankArr.length == 2
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}；民办院校数量排名前二的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}。具体如图15所示。
          </p>
          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 1 &&
              this.getSchool.privateSchoolRankArr.length == 3
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 1 &&
              this.getSchool.privateSchoolRankArr.length == 4
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}、{{
              getSchool.peopleFourth.name
            }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 1 &&
              this.getSchool.privateSchoolRankArr.length == 5
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}、{{ getSchool.peopleFourth.name }}、{{
              getSchool.peoplefive.name
            }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 1 &&
              this.getSchool.privateSchoolRankArr.length == 6
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}、{{ getSchool.peopleFourth.name }}、{{
              getSchool.peoplefive.name
            }}、{{ getSchool.peoplesix.name }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 1 &&
              this.getSchool.privateSchoolRankArr.length == 7
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}、{{ getSchool.peopleFourth.name }}、{{
              getSchool.peoplefive.name
            }}、{{ getSchool.peoplesix.name }}、{{ getSchool.peopleseven.name }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 1 &&
              this.getSchool.privateSchoolRankArr.length == 8
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}、{{ getSchool.peopleFourth.name }}、{{
              getSchool.peoplefive.name
            }}、{{ getSchool.peoplesix.name }}、{{ getSchool.peopleseven.name }}、{{
              getSchool.peopleeight.name
            }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 1 &&
              this.getSchool.privateSchoolRankArr.length == 9
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}、{{ getSchool.peopleFourth.name }}、{{
              getSchool.peoplefive.name
            }}、{{ getSchool.peoplesix.name }}、{{ getSchool.peopleseven.name }}、{{
              getSchool.peopleeight.name
            }}、{{ getSchool.peoplenine.name }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 1 &&
              this.getSchool.privateSchoolRankArr.length == 10
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}、{{ getSchool.peopleFourth.name }}、{{
              getSchool.peoplefive.name
            }}、{{ getSchool.peoplesix.name }}、{{ getSchool.peopleseven.name }}、{{
              getSchool.peopleeight.name
            }}、{{ getSchool.peoplenine.name }}、{{ getSchool.peopleten.name }}。具体如图15所示。
          </p>
        </div>
        <div>
          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 2 &&
              this.getSchool.privateSchoolRankArr.length == 0
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}；暂无民办院校排名。具体如图15所示。
          </p>
          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 2 &&
              this.getSchool.privateSchoolRankArr.length == 1
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}；民办院校数量排名前一的省份为：{{ getSchool.peopleFrist.name }}。具体如图15所示。
          </p>
          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 2 &&
              this.getSchool.privateSchoolRankArr.length == 2
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}；民办院校数量排名前二的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}。具体如图15所示。
          </p>
          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 2 &&
              this.getSchool.privateSchoolRankArr.length == 3
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 2 &&
              this.getSchool.privateSchoolRankArr.length == 4
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}、{{
              getSchool.peopleFourth.name
            }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 2 &&
              this.getSchool.privateSchoolRankArr.length == 5
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}、{{ getSchool.peopleFourth.name }}、{{
              getSchool.peoplefive.name
            }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 2 &&
              this.getSchool.privateSchoolRankArr.length == 6
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}、{{ getSchool.peopleFourth.name }}、{{
              getSchool.peoplefive.name
            }}、{{ getSchool.peoplesix.name }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 2 &&
              this.getSchool.privateSchoolRankArr.length == 7
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}、{{ getSchool.peopleFourth.name }}、{{
              getSchool.peoplefive.name
            }}、{{ getSchool.peoplesix.name }}、{{ getSchool.peopleseven.name }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 2 &&
              this.getSchool.privateSchoolRankArr.length == 8
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}、{{ getSchool.peopleFourth.name }}、{{
              getSchool.peoplefive.name
            }}、{{ getSchool.peoplesix.name }}、{{ getSchool.peopleseven.name }}、{{
              getSchool.peopleeight.name
            }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 2 &&
              this.getSchool.privateSchoolRankArr.length == 9
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}、{{ getSchool.peopleFourth.name }}、{{
              getSchool.peoplefive.name
            }}、{{ getSchool.peoplesix.name }}、{{ getSchool.peopleseven.name }}、{{
              getSchool.peopleeight.name
            }}、{{ getSchool.peoplenine.name }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 2 &&
              this.getSchool.privateSchoolRankArr.length == 10
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}、{{ getSchool.peopleFourth.name }}、{{
              getSchool.peoplefive.name
            }}、{{ getSchool.peoplesix.name }}、{{ getSchool.peopleseven.name }}、{{
              getSchool.peopleeight.name
            }}、{{ getSchool.peoplenine.name }}、{{ getSchool.peopleten.name }}。具体如图15所示。
          </p>
        </div>
        <div>
          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 3 &&
              this.getSchool.privateSchoolRankArr.length == 0
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}；暂无民办院校排名。具体如图15所示。
          </p>
          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 3 &&
              this.getSchool.privateSchoolRankArr.length == 1
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}；民办院校数量排名前一的省份为：{{
              getSchool.peopleFrist.name
            }}。具体如图15所示。
          </p>
          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 3 &&
              this.getSchool.privateSchoolRankArr.length == 2
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}；民办院校数量排名前二的省份为：{{
              getSchool.peopleFrist.name
            }}、{{ getSchool.peopleSecond.name }}。具体如图15所示。
          </p>
          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 3 &&
              this.getSchool.privateSchoolRankArr.length == 3
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}；民办院校数量排名前三的省份为：{{
              getSchool.peopleFrist.name
            }}、{{ getSchool.peopleSecond.name }}、{{
              getSchool.peopleThird.name
            }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 3 &&
              this.getSchool.privateSchoolRankArr.length == 4
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}；民办院校数量排名前三的省份为：{{
              getSchool.peopleFrist.name
            }}、{{ getSchool.peopleSecond.name }}、{{ getSchool.peopleThird.name }}、{{
              getSchool.peopleFourth.name
            }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 3 &&
              this.getSchool.privateSchoolRankArr.length == 5
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}；民办院校数量排名前三的省份为：{{
              getSchool.peopleFrist.name
            }}、{{ getSchool.peopleSecond.name }}、{{ getSchool.peopleThird.name }}、{{
              getSchool.peopleFourth.name
            }}、{{ getSchool.peoplefive.name }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 3 &&
              this.getSchool.privateSchoolRankArr.length == 6
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}；民办院校数量排名前三的省份为：{{
              getSchool.peopleFrist.name
            }}、{{ getSchool.peopleSecond.name }}、{{ getSchool.peopleThird.name }}、{{
              getSchool.peopleFourth.name
            }}、{{ getSchool.peoplefive.name }}、{{ getSchool.peoplesix.name }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 3 &&
              this.getSchool.privateSchoolRankArr.length == 7
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}；民办院校数量排名前三的省份为：{{
              getSchool.peopleFrist.name
            }}、{{ getSchool.peopleSecond.name }}、{{ getSchool.peopleThird.name }}、{{
              getSchool.peopleFourth.name
            }}、{{ getSchool.peoplefive.name }}、{{ getSchool.peoplesix.name }}、{{
              getSchool.peopleseven.name
            }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 3 &&
              this.getSchool.privateSchoolRankArr.length == 8
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}；民办院校数量排名前三的省份为：{{
              getSchool.peopleFrist.name
            }}、{{ getSchool.peopleSecond.name }}、{{ getSchool.peopleThird.name }}、{{
              getSchool.peopleFourth.name
            }}、{{ getSchool.peoplefive.name }}、{{ getSchool.peoplesix.name }}、{{
              getSchool.peopleseven.name
            }}、{{ getSchool.peopleeight.name }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 3 &&
              this.getSchool.privateSchoolRankArr.length == 9
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}；民办院校数量排名前三的省份为：{{
              getSchool.peopleFrist.name
            }}、{{ getSchool.peopleSecond.name }}、{{ getSchool.peopleThird.name }}、{{
              getSchool.peopleFourth.name
            }}、{{ getSchool.peoplefive.name }}、{{ getSchool.peoplesix.name }}、{{
              getSchool.peopleseven.name
            }}、{{ getSchool.peopleeight.name }}、{{ getSchool.peoplenine.name }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 3 &&
              this.getSchool.privateSchoolRankArr.length == 10
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.Third.name }}；民办院校数量排名前三的省份为：{{
              getSchool.peopleFrist.name
            }}、{{ getSchool.peopleSecond.name }}、{{ getSchool.peopleThird.name }}、{{
              getSchool.peopleFourth.name
            }}、{{ getSchool.peoplefive.name }}、{{ getSchool.peoplesix.name }}、{{
              getSchool.peopleseven.name
            }}、{{ getSchool.peopleeight.name }}、{{ getSchool.peoplenine.name }}、{{
              getSchool.peopleten.name
            }}。具体如图15所示。
          </p>
        </div>
        <div>
          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 4 &&
              this.getSchool.privateSchoolRankArr.length == 0
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{
              getSchool.stateFourth.name
            }}；暂无民办院校排名。具体如图15所示。
          </p>
          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 4 &&
              this.getSchool.privateSchoolRankArr.length == 1
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{
              getSchool.stateFourth.name
            }}；民办院校数量排名前一的省份为：{{ getSchool.peopleFrist.name }}。具体如图15所示。
          </p>
          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 4 &&
              this.getSchool.privateSchoolRankArr.length == 2
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{
              getSchool.stateFourth.name
            }}；民办院校数量排名前二的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}。具体如图15所示。
          </p>
          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 4 &&
              this.getSchool.privateSchoolRankArr.length == 3
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{
              getSchool.stateFourth.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 4 &&
              this.getSchool.privateSchoolRankArr.length == 4
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{
              getSchool.stateFourth.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}、{{
              getSchool.peopleFourth.name
            }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 4 &&
              this.getSchool.privateSchoolRankArr.length == 5
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{
              getSchool.stateFourth.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}、{{ getSchool.peopleFourth.name }}、{{
              getSchool.peoplefive.name
            }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 4 &&
              this.getSchool.privateSchoolRankArr.length == 6
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{
              getSchool.stateFourth.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}、{{ getSchool.peopleFourth.name }}、{{
              getSchool.peoplefive.name
            }}、{{ getSchool.peoplesix.name }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 4 &&
              this.getSchool.privateSchoolRankArr.length == 7
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{
              getSchool.stateFourth.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}、{{ getSchool.peopleFourth.name }}，{{
              getSchool.peoplefive.name
            }}、{{ getSchool.peoplesix.name }}、{{ getSchool.peopleseven.name }},具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 4 &&
              this.getSchool.privateSchoolRankArr.length == 8
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{
              getSchool.stateFourth.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}、{{ getSchool.peopleFourth.name }}，{{
              getSchool.peoplefive.name
            }}、{{ getSchool.peoplesix.name }}、{{ getSchool.peopleseven.name }}、{{
              getSchool.peopleeight.name
            }}具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 4 &&
              this.getSchool.privateSchoolRankArr.length == 9
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{
              getSchool.stateFourth.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}、{{ getSchool.peopleFourth.name }}，{{
              getSchool.peoplefive.name
            }}、{{ getSchool.peoplesix.name }}、{{ getSchool.peopleseven.name }}、{{
              getSchool.peopleeight.name
            }}、{{ getSchool.peoplenine.name }}具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 4 &&
              this.getSchool.privateSchoolRankArr.length == 10
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{
              getSchool.stateFourth.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}、{{ getSchool.peopleFourth.name }}，{{
              getSchool.peoplefive.name
            }}、{{ getSchool.peoplesix.name }}、{{ getSchool.peopleseven.name }}、{{
              getSchool.peopleeight.name
            }}、{{ getSchool.peoplenine.name }},{{ getSchool.peopleten.name }}具体如图15所示。
          </p>
        </div>
        <div>
          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 5 &&
              this.getSchool.privateSchoolRankArr.length == 0
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}；暂无民办院校排名。具体如图15所示。
          </p>
          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 5 &&
              this.getSchool.privateSchoolRankArr.length == 1
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}；民办院校数量排名前一的省份为：{{ getSchool.peopleFrist.name }}。具体如图15所示。
          </p>
          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 5 &&
              this.getSchool.privateSchoolRankArr.length == 2
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}；民办院校数量排名前二的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}。具体如图15所示。
          </p>
          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 5 &&
              this.getSchool.privateSchoolRankArr.length == 3
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 5 &&
              this.getSchool.privateSchoolRankArr.length == 4
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}、{{
              getSchool.peopleFourth.name
            }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 5 &&
              this.getSchool.privateSchoolRankArr.length == 5
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}、{{ getSchool.peopleFourth.name }}、{{
              getSchool.peoplefive.name
            }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 5 &&
              this.getSchool.privateSchoolRankArr.length == 6
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}、{{ getSchool.peopleFourth.name }}、{{
              getSchool.peoplefive.name
            }}、{{ getSchool.peoplesix.name }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 5 &&
              this.getSchool.privateSchoolRankArr.length == 7
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}、{{ getSchool.peopleFourth.name }}、{{
              getSchool.peoplefive.name
            }}、{{ getSchool.peoplesix.name }}、{{ getSchool.peopleseven.name }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 5 &&
              this.getSchool.privateSchoolRankArr.length == 8
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}、{{ getSchool.peopleFourth.name }}、{{
              getSchool.peoplefive.name
            }}、{{ getSchool.peoplesix.name }}、{{ getSchool.peopleseven.name }}、{{
              getSchool.peopleeight.name
            }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 5 &&
              this.getSchool.privateSchoolRankArr.length == 9
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}、{{ getSchool.peopleFourth.name }}、{{
              getSchool.peoplefive.name
            }}、{{ getSchool.peoplesix.name }}、{{ getSchool.peopleseven.name }}、{{
              getSchool.peopleeight.name
            }}、{{ getSchool.peoplenine.name }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 5 &&
              this.getSchool.privateSchoolRankArr.length == 10
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}、{{ getSchool.peopleFourth.name }}、{{
              getSchool.peoplefive.name
            }}、{{ getSchool.peoplesix.name }}、{{ getSchool.peopleseven.name }}、{{
              getSchool.peopleeight.name
            }}、{{ getSchool.peoplenine.name }}、{{ getSchool.peopleten.name }}。具体如图15所示。
          </p>
        </div>
        <div>
          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 6 &&
              this.getSchool.privateSchoolRankArr.length == 0
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}、{{ getSchool.statesix.name }}；暂无民办院校排名。具体如图15所示。
          </p>
          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 6 &&
              this.getSchool.privateSchoolRankArr.length == 1
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}、{{ getSchool.statesix.name }}；民办院校数量排名前一的省份为：{{
              getSchool.peopleFrist.name
            }}、具体如图15所示。
          </p>
          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 6 &&
              this.getSchool.privateSchoolRankArr.length == 2
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}、{{ getSchool.statesix.name }}；民办院校数量排名前二的省份为：{{
              getSchool.peopleFrist.name
            }}、{{ getSchool.peopleSecond.name }}。具体如图15所示。
          </p>
          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 6 &&
              this.getSchool.privateSchoolRankArr.length == 3
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}、{{ getSchool.statesix.name }}；民办院校数量排名前三的省份为：{{
              getSchool.peopleFrist.name
            }}、{{ getSchool.peopleSecond.name }}、{{
              getSchool.peopleThird.name
            }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 6 &&
              this.getSchool.privateSchoolRankArr.length == 4
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}、{{ getSchool.statesix.name }}；民办院校数量排名前三的省份为：{{
              getSchool.peopleFrist.name
            }}、{{ getSchool.peopleSecond.name }}、{{ getSchool.peopleThird.name }}、{{
              getSchool.peopleFourth.name
            }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 6 &&
              this.getSchool.privateSchoolRankArr.length == 5
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}、{{ getSchool.statesix.name }}；民办院校数量排名前三的省份为：{{
              getSchool.peopleFrist.name
            }}、{{ getSchool.peopleSecond.name }}、{{ getSchool.peopleThird.name }}、{{
              getSchool.peopleFourth.name
            }}、{{ getSchool.peoplefive.name }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 6 &&
              this.getSchool.privateSchoolRankArr.length == 6
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}、{{ getSchool.statesix.name }}；民办院校数量排名前三的省份为：{{
              getSchool.peopleFrist.name
            }}、{{ getSchool.peopleSecond.name }}、{{ getSchool.peopleThird.name }}、{{
              getSchool.peopleFourth.name
            }}、{{ getSchool.peoplefive.name }}、{{ getSchool.peoplesix.name }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 6 &&
              this.getSchool.privateSchoolRankArr.length == 7
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}、{{ getSchool.statesix.name }}；民办院校数量排名前三的省份为：{{
              getSchool.peopleFrist.name
            }}、{{ getSchool.peopleSecond.name }}、{{ getSchool.peopleThird.name }}、{{
              getSchool.peopleFourth.name
            }}、{{ getSchool.peoplefive.name }}、{{ getSchool.peoplesix.name }}、{{
              getSchool.peopleseven.name
            }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 6 &&
              this.getSchool.privateSchoolRankArr.length == 8
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}、{{ getSchool.statesix.name }}；民办院校数量排名前三的省份为：{{
              getSchool.peopleFrist.name
            }}、{{ getSchool.peopleSecond.name }}、{{ getSchool.peopleThird.name }}、{{
              getSchool.peopleFourth.name
            }}、{{ getSchool.peoplefive.name }}、{{ getSchool.peoplesix.name }}、{{
              getSchool.peopleseven.name
            }}、{{ getSchool.peopleeight.name }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 6 &&
              this.getSchool.privateSchoolRankArr.length == 9
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}、{{ getSchool.statesix.name }}；民办院校数量排名前三的省份为：{{
              getSchool.peopleFrist.name
            }}、{{ getSchool.peopleSecond.name }}、{{ getSchool.peopleThird.name }}、{{
              getSchool.peopleFourth.name
            }}、{{ getSchool.peoplefive.name }}、{{ getSchool.peoplesix.name }}、{{
              getSchool.peopleseven.name
            }}、{{ getSchool.peopleeight.name }}、{{ getSchool.peoplenine.name }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 6 &&
              this.getSchool.privateSchoolRankArr.length == 10
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}、{{ getSchool.statesix.name }}；民办院校数量排名前三的省份为：{{
              getSchool.peopleFrist.name
            }}、{{ getSchool.peopleSecond.name }}、{{ getSchool.peopleThird.name }}、{{
              getSchool.peopleFourth.name
            }}、{{ getSchool.peoplefive.name }}、{{ getSchool.peoplesix.name }}、{{
              getSchool.peopleseven.name
            }}、{{ getSchool.peopleeight.name }}、{{ getSchool.peoplenine.name }}、{{
              getSchool.peopleten.name
            }}。具体如图15所示。
          </p>
        </div>
        <div>
          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 7 &&
              this.getSchool.privateSchoolRankArr.length == 0
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}、{{ getSchool.statesix.name }}、{{
              getSchool.stateseven.name
            }}；暂无民办院校排名。具体如图15所示。
          </p>
          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 7 &&
              this.getSchool.privateSchoolRankArr.length == 1
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}、{{ getSchool.statesix.name }}、{{
              getSchool.stateseven.name
            }}；民办院校数量排名前一的省份为：{{ getSchool.peopleFrist.name }}。具体如图15所示。
          </p>
          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 7 &&
              this.getSchool.privateSchoolRankArr.length == 2
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}、{{ getSchool.statesix.name }}、{{
              getSchool.stateseven.name
            }}；民办院校数量排名前二的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}。具体如图15所示。
          </p>
          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 7 &&
              this.getSchool.privateSchoolRankArr.length == 3
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}、{{ getSchool.statesix.name }}、{{
              getSchool.stateseven.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 7 &&
              this.getSchool.privateSchoolRankArr.length == 4
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}、{{ getSchool.statesix.name }}、{{
              getSchool.stateseven.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}、{{
              getSchool.peopleFourth.name
            }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 7 &&
              this.getSchool.privateSchoolRankArr.length == 5
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}、{{ getSchool.statesix.name }}、{{
              getSchool.stateseven.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}、{{ getSchool.peopleFourth.name }}、{{
              getSchool.peoplefive.name
            }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 7 &&
              this.getSchool.privateSchoolRankArr.length == 6
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}、{{ getSchool.statesix.name }}、{{
              getSchool.stateseven.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}、{{ getSchool.peopleFourth.name }}、{{
              getSchool.peoplefive.name
            }}、{{ getSchool.peoplesix.name }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 7 &&
              this.getSchool.privateSchoolRankArr.length == 7
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}、{{ getSchool.statesix.name }}、{{
              getSchool.stateseven.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}、{{ getSchool.peopleFourth.name }}、{{
              getSchool.peoplefive.name
            }}、{{ getSchool.peoplesix.name }}、{{ getSchool.peopleseven.name }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 7 &&
              this.getSchool.privateSchoolRankArr.length == 8
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}、{{ getSchool.statesix.name }}、{{
              getSchool.stateseven.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}、{{ getSchool.peopleFourth.name }}、{{
              getSchool.peoplefive.name
            }}、{{ getSchool.peoplesix.name }}、{{ getSchool.peopleseven.name }}、{{
              getSchool.peopleeight.name
            }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 7 &&
              this.getSchool.privateSchoolRankArr.length == 9
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}、{{ getSchool.statesix.name }}、{{
              getSchool.stateseven.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}、{{ getSchool.peopleFourth.name }}、{{
              getSchool.peoplefive.name
            }}、{{ getSchool.peoplesix.name }}、{{ getSchool.peopleseven.name }}、{{
              getSchool.peopleeight.name
            }}、{{ getSchool.peoplenine.name }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 7 &&
              this.getSchool.privateSchoolRankArr.length == 10
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}、{{ getSchool.statesix.name }}、{{
              getSchool.stateseven.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}、{{ getSchool.peopleFourth.name }}、{{
              getSchool.peoplefive.name
            }}、{{ getSchool.peoplesix.name }}、{{ getSchool.peopleseven.name }}、{{
              getSchool.peopleeight.name
            }}、{{ getSchool.peoplenine.name }}、{{ getSchool.peopleten.name }}。具体如图15所示。
          </p>
        </div>
        <div>
          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 8 &&
              this.getSchool.privateSchoolRankArr.length == 0
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}、{{ getSchool.statesix.name }}、{{ getSchool.stateseven.name }}、{{
              getSchool.stateeight.name
            }}；暂无民办院校排名。具体如图15所示。
          </p>
          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 8 &&
              this.getSchool.privateSchoolRankArr.length == 1
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}、{{ getSchool.statesix.name }}、{{ getSchool.stateseven.name }}、{{
              getSchool.stateeight.name
            }}；民办院校数量排名前一的省份为：{{ getSchool.peopleFrist.name }}，具体如图15所示。
          </p>
          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 8 &&
              this.getSchool.privateSchoolRankArr.length == 2
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}、{{ getSchool.statesix.name }}、{{ getSchool.stateseven.name }}、{{
              getSchool.stateeight.name
            }}；民办院校数量排名前二的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}。具体如图15所示。
          </p>
          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 8 &&
              this.getSchool.privateSchoolRankArr.length == 3
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}、{{ getSchool.statesix.name }}、{{ getSchool.stateseven.name }}、{{
              getSchool.stateeight.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 8 &&
              this.getSchool.privateSchoolRankArr.length == 4
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}、{{ getSchool.statesix.name }}、{{ getSchool.stateseven.name }}、{{
              getSchool.stateeight.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}、{{
              getSchool.peopleFourth.name
            }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 8 &&
              this.getSchool.privateSchoolRankArr.length == 5
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}、{{ getSchool.statesix.name }}、{{ getSchool.stateseven.name }}、{{
              getSchool.stateeight.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}、{{ getSchool.peopleFourth.name }}、{{
              getSchool.peoplefive.name
            }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 8 &&
              this.getSchool.privateSchoolRankArr.length == 6
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}、{{ getSchool.statesix.name }}、{{ getSchool.stateseven.name }}、{{
              getSchool.stateeight.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}、{{ getSchool.peopleFourth.name }}、{{
              getSchool.peoplefive.name
            }}、{{ getSchool.peoplesix.name }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 8 &&
              this.getSchool.privateSchoolRankArr.length == 7
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}、{{ getSchool.statesix.name }}、{{ getSchool.stateseven.name }}、{{
              getSchool.stateeight.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}、{{ getSchool.peopleFourth.name }}、{{
              getSchool.peoplefive.name
            }}、{{ getSchool.peoplesix.name }}、{{ getSchool.peopleseven.name }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 8 &&
              this.getSchool.privateSchoolRankArr.length == 8
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}、{{ getSchool.statesix.name }}、{{ getSchool.stateseven.name }}、{{
              getSchool.stateeight.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}、{{ getSchool.peopleFourth.name }}、{{
              getSchool.peoplefive.name
            }}、{{ getSchool.peoplesix.name }}、{{ getSchool.peopleseven.name }}、{{
              getSchool.peopleeight.name
            }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 8 &&
              this.getSchool.privateSchoolRankArr.length == 9
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}、{{ getSchool.statesix.name }}、{{ getSchool.stateseven.name }}、{{
              getSchool.stateeight.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}、{{ getSchool.peopleFourth.name }}、{{
              getSchool.peoplefive.name
            }}、{{ getSchool.peoplesix.name }}、{{ getSchool.peopleseven.name }}、{{
              getSchool.peopleeight.name
            }}、{{ getSchool.peoplenine.name }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 8 &&
              this.getSchool.privateSchoolRankArr.length == 10
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}、{{ getSchool.statesix.name }}、{{ getSchool.stateseven.name }}、{{
              getSchool.stateeight.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}、{{ getSchool.peopleFourth.name }}、{{
              getSchool.peoplefive.name
            }}、{{ getSchool.peoplesix.name }}、{{ getSchool.peopleseven.name }}、{{
              getSchool.peopleeight.name
            }}、{{ getSchool.peoplenine.name }},{{ getSchool.peopleten.name }}。具体如图15所示。
          </p>
        </div>
        <div>
          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 9 &&
              this.getSchool.privateSchoolRankArr.length == 0
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}、{{ getSchool.statesix.name }}、{{ getSchool.stateseven.name }}、{{
              getSchool.stateeight.name
            }}、{{ getSchool.statenine.name }}；暂无民办院校排名。具体如图15所示。
          </p>
          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 9 &&
              this.getSchool.privateSchoolRankArr.length == 1
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}、{{ getSchool.statesix.name }}、{{ getSchool.stateseven.name }}、{{
              getSchool.stateeight.name
            }}、{{ getSchool.statenine.name }}；民办院校数量排名前一的省份为：{{
              getSchool.peopleFrist.name
            }}。具体如图15所示。
          </p>
          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 9 &&
              this.getSchool.privateSchoolRankArr.length == 2
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}、{{ getSchool.statesix.name }}、{{ getSchool.stateseven.name }}、{{
              getSchool.stateeight.name
            }}、{{ getSchool.statenine.name }}；民办院校数量排名前二的省份为：{{
              getSchool.peopleFrist.name
            }}、{{ getSchool.peopleSecond.name }}。具体如图15所示。
          </p>
          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 9 &&
              this.getSchool.privateSchoolRankArr.length == 3
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}、{{ getSchool.statesix.name }}、{{ getSchool.stateseven.name }}、{{
              getSchool.stateeight.name
            }}、{{ getSchool.statenine.name }}；民办院校数量排名前三的省份为：{{
              getSchool.peopleFrist.name
            }}、{{ getSchool.peopleSecond.name }}、{{
              getSchool.peopleThird.name
            }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 9 &&
              this.getSchool.privateSchoolRankArr.length == 4
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}、{{ getSchool.statesix.name }}、{{ getSchool.stateseven.name }}、{{
              getSchool.stateeight.name
            }}、{{ getSchool.statenine.name }}；民办院校数量排名前三的省份为：{{
              getSchool.peopleFrist.name
            }}、{{ getSchool.peopleSecond.name }}、{{ getSchool.peopleThird.name }}、{{
              getSchool.peopleFourth.name
            }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 9 &&
              this.getSchool.privateSchoolRankArr.length == 5
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}、{{ getSchool.statesix.name }}、{{ getSchool.stateseven.name }}、{{
              getSchool.stateeight.name
            }}、{{ getSchool.statenine.name }}；民办院校数量排名前三的省份为：{{
              getSchool.peopleFrist.name
            }}、{{ getSchool.peopleSecond.name }}、{{ getSchool.peopleThird.name }}、{{
              getSchool.peopleFourth.name
            }}、{{ getSchool.peoplefive.name }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 9 &&
              this.getSchool.privateSchoolRankArr.length == 6
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}、{{ getSchool.statesix.name }}、{{ getSchool.stateseven.name }}、{{
              getSchool.stateeight.name
            }}、{{ getSchool.statenine.name }}；民办院校数量排名前三的省份为：{{
              getSchool.peopleFrist.name
            }}、{{ getSchool.peopleSecond.name }}、{{ getSchool.peopleThird.name }}、{{
              getSchool.peopleFourth.name
            }}、{{ getSchool.peoplefive.name }}、{{ getSchool.peoplesix.name }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 9 &&
              this.getSchool.privateSchoolRankArr.length == 7
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}、{{ getSchool.statesix.name }}、{{ getSchool.stateseven.name }}、{{
              getSchool.stateeight.name
            }}、{{ getSchool.statenine.name }}；民办院校数量排名前三的省份为：{{
              getSchool.peopleFrist.name
            }}、{{ getSchool.peopleSecond.name }}、{{ getSchool.peopleThird.name }}、{{
              getSchool.peopleFourth.name
            }}、{{ getSchool.peoplefive.name }}、{{ getSchool.peoplesix.name }}、{{
              getSchool.peopleseven.name
            }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 9 &&
              this.getSchool.privateSchoolRankArr.length == 8
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}、{{ getSchool.statesix.name }}、{{ getSchool.stateseven.name }}、{{
              getSchool.stateeight.name
            }}、{{ getSchool.statenine.name }}；民办院校数量排名前三的省份为：{{
              getSchool.peopleFrist.name
            }}、{{ getSchool.peopleSecond.name }}、{{ getSchool.peopleThird.name }}、{{
              getSchool.peopleFourth.name
            }}、{{ getSchool.peoplefive.name }}、{{ getSchool.peoplesix.name }}、{{
              getSchool.peopleseven.name
            }}、{{ getSchool.peopleeight.name }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 9 &&
              this.getSchool.privateSchoolRankArr.length == 9
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}、{{ getSchool.statesix.name }}、{{ getSchool.stateseven.name }}、{{
              getSchool.stateeight.name
            }}、{{ getSchool.statenine.name }}；民办院校数量排名前三的省份为：{{
              getSchool.peopleFrist.name
            }}、{{ getSchool.peopleSecond.name }}、{{ getSchool.peopleThird.name }}、{{
              getSchool.peopleFourth.name
            }}、{{ getSchool.peoplefive.name }}、{{ getSchool.peoplesix.name }}、{{
              getSchool.peopleseven.name
            }}、{{ getSchool.peopleeight.name }}、{{ getSchool.peoplenine.name }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 9 &&
              this.getSchool.privateSchoolRankArr.length == 10
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}、{{ getSchool.statesix.name }}、{{ getSchool.stateseven.name }}、{{
              getSchool.stateeight.name
            }}、{{ getSchool.statenine.name }}；民办院校数量排名前三的省份为：{{
              getSchool.peopleFrist.name
            }}、{{ getSchool.peopleSecond.name }}、{{ getSchool.peopleThird.name }}、{{
              getSchool.peopleFourth.name
            }}、{{ getSchool.peoplefive.name }}、{{ getSchool.peoplesix.name }}、{{
              getSchool.peopleseven.name
            }}、{{ getSchool.peopleeight.name }}、{{ getSchool.peoplenine.name }}、{{
              getSchool.peopleten.name
            }}。具体如图15所示。
          </p>
        </div>
        <div>
          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 10 &&
              this.getSchool.privateSchoolRankArr.length == 0
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}、{{ getSchool.statesix.name }}、{{ getSchool.stateseven.name }}、{{
              getSchool.stateeight.name
            }}、{{ getSchool.statenine.name }}、{{
              getSchool.stateten.name
            }}；暂无民办院校排名。具体如图15所示。
          </p>
          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 10 &&
              this.getSchool.privateSchoolRankArr.length == 1
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}、{{ getSchool.statesix.name }}、{{ getSchool.stateseven.name }}、{{
              getSchool.stateeight.name
            }}、{{ getSchool.statenine.name }}、{{
              getSchool.stateten.name
            }}；民办院校数量排名前一的省份为：{{ getSchool.peopleFrist.name }}。具体如图15所示。
          </p>
          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 10 &&
              this.getSchool.privateSchoolRankArr.length == 2
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}、{{ getSchool.statesix.name }}、{{ getSchool.stateseven.name }}、{{
              getSchool.stateeight.name
            }}、{{ getSchool.statenine.name }}、{{
              getSchool.stateten.name
            }}；民办院校数量排名前二的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}。具体如图15所示。
          </p>
          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 10 &&
              this.getSchool.privateSchoolRankArr.length == 3
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}、{{ getSchool.statesix.name }}、{{ getSchool.stateseven.name }}、{{
              getSchool.stateeight.name
            }}、{{ getSchool.statenine.name }}、{{
              getSchool.stateten.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 10 &&
              this.getSchool.privateSchoolRankArr.length == 4
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}、{{ getSchool.statesix.name }}、{{ getSchool.stateseven.name }}、{{
              getSchool.stateeight.name
            }}、{{ getSchool.statenine.name }}、{{
              getSchool.stateten.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}、{{
              getSchool.peopleFourth.name
            }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 10 &&
              this.getSchool.privateSchoolRankArr.length == 5
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}、{{ getSchool.statesix.name }}、{{ getSchool.stateseven.name }}、{{
              getSchool.stateeight.name
            }}、{{ getSchool.statenine.name }}、{{
              getSchool.stateten.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}、{{ getSchool.peopleFourth.name }}、{{
              getSchool.peoplefive.name
            }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 10 &&
              this.getSchool.privateSchoolRankArr.length == 6
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}、{{ getSchool.statesix.name }}、{{ getSchool.stateseven.name }}、{{
              getSchool.stateeight.name
            }}、{{ getSchool.statenine.name }}、{{
              getSchool.stateten.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}、{{ getSchool.peopleFourth.name }}、{{
              getSchool.peoplefive.name
            }}、{{ getSchool.peoplesix.name }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 10 &&
              this.getSchool.privateSchoolRankArr.length == 7
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}、{{ getSchool.statesix.name }}、{{ getSchool.stateseven.name }}、{{
              getSchool.stateeight.name
            }}、{{ getSchool.statenine.name }}、{{
              getSchool.stateten.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}、{{ getSchool.peopleFourth.name }}、{{
              getSchool.peoplefive.name
            }}、{{ getSchool.peoplesix.name }}、{{ getSchool.peopleseven.name }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 10 &&
              this.getSchool.privateSchoolRankArr.length == 8
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}、{{ getSchool.statesix.name }}、{{ getSchool.stateseven.name }}、{{
              getSchool.stateeight.name
            }}、{{ getSchool.statenine.name }}、{{
              getSchool.stateten.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}、{{ getSchool.peopleFourth.name }}、{{
              getSchool.peoplefive.name
            }}、{{ getSchool.peoplesix.name }}、{{ getSchool.peopleseven.name }}、{{
              getSchool.peopleeight.name
            }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 10 &&
              this.getSchool.privateSchoolRankArr.length == 9
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}、{{ getSchool.statesix.name }}、{{ getSchool.stateseven.name }}、{{
              getSchool.stateeight.name
            }}、{{ getSchool.statenine.name }}、{{
              getSchool.stateten.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}、{{ getSchool.peopleFourth.name }}、{{
              getSchool.peoplefive.name
            }}、{{ getSchool.peoplesix.name }}、{{ getSchool.peopleseven.name }}、{{
              getSchool.peopleeight.name
            }}、{{ getSchool.peoplenine.name }}。具体如图15所示。
          </p>

          <p
            v-show="
              this.getSchool.publicSchoolRankArr.length == 10 &&
              this.getSchool.privateSchoolRankArr.length == 10
            "
          >
            在该时间段内系统统计显示，开办{{
              essential.majorName
            }}专业的公办院校数量排名前三的省份为：{{ getSchool.stateFrist.name }}、{{
              getSchool.stateSecond.name
            }}、{{ getSchool.stateThird.name }}、{{ getSchool.stateFourth.name }}、{{
              getSchool.statefive.name
            }}、{{ getSchool.statesix.name }}、{{ getSchool.stateseven.name }}、{{
              getSchool.stateeight.name
            }}、{{ getSchool.statenine.name }}、{{
              getSchool.stateten.name
            }}；民办院校数量排名前三的省份为：{{ getSchool.peopleFrist.name }}、{{
              getSchool.peopleSecond.name
            }}、{{ getSchool.peopleThird.name }}、{{ getSchool.peopleFourth.name }}、{{
              getSchool.peoplefive.name
            }}、{{ getSchool.peoplesix.name }}、{{ getSchool.peopleseven.name }}、{{
              getSchool.peopleeight.name
            }}、{{ getSchool.peoplenine.name }}、{{ getSchool.peopleten.name }}。具体如图15所示。
          </p>
        </div>
        <div class="standards_content echartsHeight">
          <stcolumnarChart
            :isShowTextColor="true"
            :refId="'lastcoursesMonthChart'"
            :legendList="getSchool.legendList"
            :datas="getSchool.dataList"
            :yAxisList="getSchool.transverseData"
            :colorList="colorList"
            :innerText="'单位：门'"
          >
          </stcolumnarChart>
        </div>
        <div class="chart_name">图15 本专业开设院校办学性质分布</div>
        <h4 style="margin-top: 150px">3.2 本专业开设院校地域分布</h4>
        <p>
          据{{ nowYearText }}年备案信息结果显示，{{
            essential.majorName
          }}专业开设点排名前三的区域有：{{ getSchoolRegion.firstObj.name
          }}{{ getSchoolRegion.firstObj.value }}个、{{ getSchoolRegion.secondObj.name
          }}{{ getSchoolRegion.secondObj.value }}个、{{ getSchoolRegion.thirdObj.name
          }}{{ getSchoolRegion.thirdObj.value }}个。具体如图16所示。
        </p>
        <div class="standards_content echartsHeight">
          <circularChart
            :isShowTextColor="true"
            :refId="'typeDistributionChart'"
            :datas="getSchoolRegion.dataList"
            :colorName="1"
            :innerText="'数量'"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :legendLeft="'55%'"
            :circleSize="80"
            :legendListFontSize="30"
          />
        </div>
        <div class="chart_name">图16 本专业开设院校地域分布</div>
      </div>

      <div class="chart_box page-box">
        <h4>3.3 本专业岗位需求数量分布</h4>
        <p>
          在该时间段内系统统计显示{{ essential.majorName }}专业岗位需求数量排名前五的城市有：{{
            map.Frist1.name
          }}{{ map.Frist1.value }}个、{{ map.Second1.name }}{{ map.Second1.value }}个、{{
            map.Third1.name
          }}{{ map.Third1.value }}个、{{ map.Fourth1.name }}{{ map.Fourth1.value }}个、{{
            map.fifth1.name
          }}{{ map.fifth1.value }}个。具体如图17所示。
        </p>
        <div class="standards_content echartsHeight" style="height: 48.75rem">
          <hotMapChart
            :refId="'mapChart'"
            :datas="map.dataList"
            :legendList="map.legendList"
            :colorList="mapColorList"
            :nameColor="'black'"
            :Size="'1.25rem'"
          />
        </div>
        <div class="chart_name">图17 本专业开设点数与岗位需求数量分布</div>
        <h4 class="m-top150">3.4 本专业市场需求地域分布</h4>
        <p>
          在该时间段内系统统计显示，面向{{ essential.majorName }}专业地区发布招聘岗位数量最多的为{{
            salaryposts.Frist.name
          }}地区，{{ dataHandler(salaryposts.Frist.value) }}个。具体如图18所示。
        </p>
        <div class="standards_content echartsHeight">
          <pieChart
            :refId="'universitiesChart'"
            :datas="salaryposts.dataList"
            :colorList="salaryposts.colorList"
            :nameColor="'black'"
          />
        </div>
        <div class="chart_name">图18 本专业市场需求地域分布</div>
      </div>

      <div class="chart_box page-box flex-box">
        <div>
          <h4>3.5 本专业市场需求所属行业分布</h4>
          <p>
            在该时间段内系统统计显示，{{
              essential.majorName
            }}专业可从事行业岗位招聘数量排名前三的分别为：{{ distribution.Frist.name }}，{{
              distribution.Frist.value
            }}个岗位；{{ distribution.Second.name }}，{{ distribution.Second.value }}个岗位；{{
              distribution.Third.name
            }}，{{ distribution.Third.value }}个岗位。具体如图19所示。
          </p>
          <div class="standards_content echartsHeight">
            <circularChart
              :isShowTextColor="true"
              :refId="'typeDistributionChart'"
              :datas="distribution.dataList"
              :colorName="1"
              :innerText="'数量'"
              :titleLeft="'16%'"
              :seriesRight="'68%'"
              :legendBackgroundColor="true"
              :legendLeft="'40%'"
              :circleSize="80"
              :legendListFontSize="30"
            />
          </div>
          <div class="chart_name">图19 本专业市场需求所属行业分布</div>
        </div>
        <div>
          <h4>3.6 本专业招聘单位类型分布</h4>
          <p>
            在该时间段内系统统计显示，面向{{
              essential.majorName
            }}专业招聘单位分布排名前三的单位类型、数量情况：{{ discipline.Frist.name
            }}{{ dataHandler(discipline.Frist.value) }}个；{{ discipline.Second.name
            }}{{ dataHandler(discipline.Second.value) }}个；{{ discipline.Third.name
            }}{{ dataHandler(discipline.Third.value) }}个。具体如图20所示。
          </p>
          <div class="standards_content echartsHeight">
            <circularChart
              :isShowTextColor="true"
              :refId="'typeDistributionChart'"
              :datas="discipline.dataList"
              :colorName="1"
              :innerText="'数量'"
              :titleLeft="'15%'"
              :seriesRight="'68%'"
              :legendBackgroundColor="true"
              :legendLeft="'40%'"
              :circleSize="80"
              :legendListFontSize="30"
            />
          </div>
          <div class="chart_name">图20 本专业招聘单位类型分布</div>
        </div>
        <div>
          <h4>3.7 本专业市场需求行业企业分布情况</h4>
          <p>
            在该时间段内系统统计显示，{{
              essential.majorName
            }}专业毕业生可从事行业的企业需求数量排名前三的分别为：{{ getProfession.Frist.name }}，{{
              dataHandler(getProfession.Frist.num)
            }}家；{{ getProfession.Second.name }}，{{ dataHandler(getProfession.Second.num) }}家；{{
              getProfession.Third.name
            }}，{{ dataHandler(getProfession.Third.num) }}家。具体如图21所示。
          </p>
          <div class="standards_content echartsHeight">
            <tcolumnarChart
              :refId="'rankingChart'"
              :isExportTextColor="true"
              :isShowTextColor="true"
              :datas="getProfession.dataList"
              :transverseData="getProfession.transverseData"
              :colorList="colorList"
              :gridY="'12%'"
            />
          </div>
          <div class="chart_name">图21 本专业市场需求行业企业分布情况</div>
        </div>
      </div>

      <div class="chart_box page-box flex-box">
        <div>
          <h4>3.8 本专业面向职业需求排名</h4>
          <p v-if="ranking.dataList.length >= 3">
            在该时间段内系统统计显示，{{
              essential.majorName
            }}专业面向的职业需求数量排名前三的有：{{ ranking.Frist.name
            }}{{ this.dataHandler(ranking.Frist.num) }}个、{{ ranking.Second.name
            }}{{ this.dataHandler(ranking.Second.num) }}个、{{ ranking.Third.name
            }}{{ this.dataHandler(ranking.Third.num) }}个。具体如图22所示。
          </p>
          <p v-else-if="ranking.dataList.length === 2">
            在该时间段内系统统计显示，{{
              essential.majorName
            }}专业面向的职业需求数量排名前二的有：{{ ranking.Frist.name
            }}{{ this.dataHandler(ranking.Frist.num) }}个、{{ ranking.Second.name
            }}{{ this.dataHandler(ranking.Second.num) }}个。具体如图22所示。
          </p>
          <p v-else-if="ranking.dataList.length === 1">
            在该时间段内系统统计显示，{{
              essential.majorName
            }}专业面向的职业需求数量排名第一的有：{{ ranking.Frist.name
            }}{{ this.dataHandler(ranking.Frist.num) }}个。具体如图22所示。
          </p>
          <div class="standards_content echartsHeight">
            <tcolumnarChart
              :isExportTextColor="true"
              :isShowTextColor="true"
              :refId="'rankingChart'"
              :datas="ranking.dataList"
              :transverseData="ranking.transverseData"
              :colorList="colorList"
              :gridY="'12%'"
              :gridHeight="'83%'"
            />
          </div>
          <div class="chart_name">图22 本专业面向职业需求排名</div>
        </div>

        <div>
          <h4>3.9 本专业面向职业薪酬排名</h4>
          <p v-if="posts.dataList.length >= 3">
            在该时间段内系统统计显示，{{ essential.majorName }}专业面向的职业薪酬排名前三的有：{{
              posts.Frist.name
            }}{{ this.dataHandler(posts.Frist.num) }}元/月、{{ posts.Second.name
            }}{{ this.dataHandler(posts.Second.num) }}元/月、{{ posts.Third.name
            }}{{ this.dataHandler(posts.Third.num) }}元/月。具体如图23所示。
          </p>
          <p v-else-if="posts.dataList.length === 2">
            在该时间段内系统统计显示，{{ essential.majorName }}专业面向的职业薪酬排名前二的有：{{
              posts.Frist.name
            }}{{ this.dataHandler(posts.Frist.num) }}元/月、{{ posts.Second.name
            }}{{ this.dataHandler(posts.Second.num) }}元/月。具体如图23所示。
          </p>
          <p v-else-if="posts.dataList.length === 1">
            在该时间段内系统统计显示，{{ essential.majorName }}专业面向的职业薪酬排名第一的有：{{
              posts.Frist.name
            }}{{ this.dataHandler(posts.Frist.num) }}元/月。具体如图23所示。
          </p>
          <div class="standards_content echartsHeight">
            <tcolumnarChart
              :isExportTextColor="true"
              :isShowTextColor="true"
              :refId="'rankingChart'"
              :datas="posts.dataList"
              :transverseData="posts.transverseData"
              :colorList="colorList"
              :gridY="'5%'"
              :gridHeight="'83%'"
            />
          </div>
          <div class="chart_name">图23 本专业面向职业薪酬排名</div>
        </div>

        <div>
          <h4>3.10 本专业面向职业发展方向分布</h4>
          <p v-if="getDevelopment.dataList.length >= 3">
            在该时间段内系统统计显示，{{
              essential.majorName
            }}专业毕业生职业发展方向岗位招聘数量排名前三的分别为：{{ getDevelopment.Frist.name
            }}{{ this.dataHandler(getDevelopment.Frist.value) }}个、{{ getDevelopment.Second.name
            }}{{ this.dataHandler(getDevelopment.Second.value) }}个，{{ getDevelopment.Third.name
            }}{{ this.dataHandler(getDevelopment.Third.value) }}个。具体如图24所示。
          </p>

          <p v-else-if="getDevelopment.dataList.length == 2">
            在该时间段内系统统计显示，{{
              essential.majorName
            }}专业毕业生职业发展方向岗位招聘数量排名前二的分别为：{{ getDevelopment.Frist.name
            }}{{ this.dataHandler(getDevelopment.Frist.value) }}个、{{ getDevelopment.Second.name
            }}{{ this.dataHandler(getDevelopment.Second.value) }}个。具体如图24所示。
          </p>

          <p v-else-if="getDevelopment.dataList.length == 1">
            在该时间段内系统统计显示，{{
              essential.majorName
            }}专业毕业生职业发展方向岗位招聘数量排名第一的为：{{ getDevelopment.Frist.name
            }}{{ this.dataHandler(getDevelopment.Frist.value) }}个。具体如图24所示。
          </p>

          <div class="standards_content echartsHeight">
            <pieChart
              :refId="'universitiesChart'"
              :datas="getDevelopment.dataList"
              :colorList="getDevelopment.colorList"
              :nameColor="'black'"
              :top="'8%'"
              :radius="'60%'"
            />
          </div>
          <div class="chart_name">图24 本专业面向职业发展方向分布</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import circularChart from "@/components/chart/circularChart.vue"; //引入圆形图表
import vcolumnarChart from "@/components/chart/vcolumnarChart.vue"; //引入竖柱状图图表
import tcolumnarChart from "@/components/chart/tcolumnarChart.vue"; //引入横柱图图表
import discountChart from "@/components/chart/discountChart.vue"; //引入折现图图表
import waterDropChart from "@/components/chart/waterDropChart.vue"; //引入水滴图图表
import hotMapChart from "@/components/chart/hotMapChart.vue"; //专业就业地图
import stcolumnarChart from "@/components/chart/stcolumnarChart.vue"; //双柱状图
import pieChart from "@/components/chart/pieChart.vue"; //  饼状图
import pageToPDF from "@/utils/htmlToPdf.js";

export default {
  components: {
    circularChart,
    vcolumnarChart,
    tcolumnarChart,
    discountChart,
    waterDropChart,
    hotMapChart,
    stcolumnarChart,
    pieChart,
  },
  data() {
    return {
      completeNum: 0, //统计接口数量
      list: [
        {
          td1: ["专业代码："],
        },
        {
          td1: ["专业名称："],
        },
        {
          td1: ["职业面向："],
        },
        {
          td1: ["培养目标定位："],
        },
        {
          td1: ["专业基础课程："],
        },
        {
          td1: ["专业核心课程："],
        },
        {
          td1: ["专业拓展课程："],
        },
        {
          td1: ["职业技能等级证书："],
        },
        {
          td1: ["接续高职本科："],
        },
        {
          td1: ["接续普通本科："],
        },
      ],
      essential: {
        majorCode: "",
        majorname: "",
        value: null,
        professionalFace: "",
        trainingObjectives: "",
        basicsCourse: "",
        coreCourse: "",
        internship: "",
        professionalLevelBook: "",
        highProfessionUndergraduate: "",
        ordinaryUndergraduate: "",
      },
      year: "",
      monthly: "",
      yearMonthText: "",
      nowYearText: "",
      nowQuarterText: "",
      lastQuarterText: "",
      allHostUnit: "",
      colorList: [
        "#3B85FB",
        "#FD398E",
        "#8B68F1",
        "#EE6F5E",
        "#E0D35F",
        "#5470C6",
        "#DE7E4B",
        "#DE524B",
      ], //柱状图或折线图的颜色
      mapColorList: ["#40f1f6", "#fd891c"],
      barColorList: ["#3B85FB", "#BBA8FF"],
      header: {
        zykname: "",
        value: null,
        zykNum: "",
        startTime: "",
        endTime: "",
        yearOrMonth: "",
      },
      resourceLibrary: {
        //图1 当前资源库用户情况
        dataList: [],
        total: 0,
        teacherNum: 0,
        studentNum: 0,
        enterpriseNum: 0,
        socialNum: 0,
        otherNum: 0,
      },
      userCountUnit: {
        //图2 当前资源库参建单位注册用户情况（主持单位学生 + 老师，参建单位用户人数）
        teacherList: [],
        studentList: [],
        teacherNum: 0,
        studentNum: 0,
        zcteacherNum: 0,
        zcstudentNum: 0,
      },

      typeDistribution: {
        //图3 资源库素材资源类型分布
        dataList: [],
        spNumber: 0,
        dhNumber: 0,
        txtxNumber: 0,
        xnfzNumber: 0,
        wbNumber: 0,
        wkNumber: 0,
        ypNumber: 0,
        kjNumber: 0,
        pptNumber: 0,
        fmtNumber: 0,
        qtNumber: 0,
        total: 0,
      },
      standardization: {
        //图4 该资源库标准化课程活跃用户排名
        dataList: [],
        transverseData: [],
        courseBzNum: 0,
      },
      behaviorTypes: {
        //图5 资源库用户行为类型分布
        dataList: [],
        total: 0,
        loginModule: 0,
        courseModule: 0,
        resourceModule: 0,
        forumModule: 0,
        taskModule: 0,
        examinationModule: 0,
        otherModule: 0,
      },

      waterDrop: {
        teacher: 0, //图6 资源库无活动数据情况
        student: 0, //图6 资源库无活动数据情况
        resource: 0, //图6 资源库无活动数据情况
        // lastresource: 0,    //图11 资源库无访问资源较上月变化情况
        majorteacher: 0, //图8 主持院校与参建院校新增占比情况
        majorstudent: 0, //图8 主持院校与参建院校新增占比情况
        unitteacher: 0, //图8 主持院校与参建院校新增占比情况
        unitstudent: 0, //图8 主持院校与参建院校新增占比情况
        teacherNum: 0,
        studentNum: 0,
        resourceNum: 0,
        lastresourceNum: 0,
        majorteacherNum: 0,
        majorstudentNum: 0,
        unitteacherNum: 0,
        unitstudentNum: 0,
      },
      usersMonth: {
        //图7 本季度用户新增情况
        dataList: [],
        transverseData: [],
        legendList: [],
        teacherNum: 0,
        studentNum: 0,
        enterpriseNum: 0,
        socialNum: 0,
        otherNum: 0,
        total: 0,
      },
      verticalBar: {
        //图9 资源库无活动师生数据变化情况
        dataList: [],
        transverseData: [],
        legendList: [],
      },
      resourcesMonth: {
        //图10 资源库各类型素材资源新增情况
        dataList: [],
        total: 0,
      },
      materialMonth: {
        dataList: [],
        legendList: [],
        transverseData: [],
      },
      coursesMonth: {
        //图12 本月课程新增情况
        dataList: [],
        legendList: [],
        transverseData: [],
        standardNum: 0,
        personalityNum: 0,
      },
      accessMonth: {
        //图13 本月资源访问情况
        dataList: [],
        transverseData: [],
        legendList: [],
        total: 0,
      },
      visitsMonth: {
        //图14 本月课程访问情况
        dataList: [],
        transverseData: [],
        legendList: [],
        total: 0,
      },
      userAccessMonth: {
        //图15 本月用户访问情况
        dataList: [],
        transverseData: [],
        legendList: [],
        total: 0,
      },
      behaviorUser: {
        //图16 本月用户访问时间段分布
        dataList: [],
        transverseData: [],
        legendList: [],
        total: 0,
      },
      tearcherList: {
        // 表1  本月访问较多的教师
        dataList: [],
      },
      studentList: {
        // 表2 本月访问较多的学生
        dataList: [],
      },
      resourcePool: {
        //图6 资源库无活动数据情况,图9 资源库无活动师生数据变化情况,图11 资源库无访问资源较上月变化情况
        countTeacher: 0,
        countStudent: 0,
        realTeacher: 0,
        realStudent: 0,
        countResource: 0,
      },

      majorUser: {
        //图8 主持院校与参建院校新增占比情况
        teacher: 0,
        student: 0,
        cjteacher: 0,
        cjstudent: 0,
      },
      lastMonth: {
        //图9 资源库无活动师生数据变化情况,图11 资源库无访问资源较上月变化情况,图12 本月课程新增情况
        noAccessTeacher: 0, //无活动教师
        noAccessStudent: 0, //无活动学生
        noAccessResource: 0, //无活动资源
        videoNum: 0,
        animationNum: 0,
        graphicImageNum: 0,
        virtualSimulationNum: 0,
        textNum: 0,
        smallCourseNum: 0,
        shenyangNum: 0,
        coursewareNum: 0,
        pptNum: 0,
        mediaNum: 0,
        otherNum: 0,
        standardNum: 0, //标准化课程
        personalityNum: 0, //个性化课程
        resourceTotal: 0,
      },
      LastMoth: {
        dataList: [],
        wufagnwennumber: 0,
        noAccessTeacher: 0,
        noAccessStudent: 0,
        noAccessResource: 0,

        noAccessResourceList: 0,
      },
      ben: {
        dataList: [],
        wufagnwennumber: 0,
        noAccessTeacher: 0,
        noAccessStudent: 0,
        noAccessResource: 0,
        noAccessResourceList: 0,
      },
      Andlastresource: {
        noAccessResource: null,
        lastMonthNoAccessResource: null,
      },

      map: {
        arr1: [],
        arr2: [],
        dataList: [],
        legendList: ["岗位需求数", "专业开设点数"],
        Frist1: { name: "" },
        Second1: { name: "" },
        Third1: { name: "" },
        Fourth1: { name: "" },
        fifth1: { name: "" },
        Frist: { name: "" },
        Second: { name: "" },
        Third: { name: "" },
        Fourth: { name: "" },
        fifth: { name: "" },
      },
      getSchool: {
        dataList: [],
        transverseData: [],
        legendList: ["公办", "民办"],
        stateArr: [],
        peopleArr: [],
        publicSchoolRankArr: [],
        privateSchoolRankArr: [],
        // 公办
        stateFrist: {
          name: "",
          value: null,
        },
        stateSecond: {
          name: "",
          value: null,
        },
        stateThird: {
          name: "",
          value: null,
        },
        stateFourth: {
          name: "",
          value: null,
        },
        statefive: {
          name: "",
          value: null,
        },
        statesix: {
          name: "",
          value: null,
        },
        stateseven: {
          name: "",
          value: null,
        },
        stateeight: {
          name: "",
          value: null,
        },
        statenine: {
          name: "",
          value: null,
        },
        stateten: {
          name: "",
          value: null,
        },
        // 民办
        peopleFrist: {
          name: "",
          value: null,
        },
        peopleSecond: {
          name: "",
          value: null,
        },
        peopleThird: {
          name: "",
          value: null,
        },
        peopleFourth: {
          name: "",
          value: null,
        },
        peoplefive: {
          name: "",
          value: null,
        },
        peoplesix: {
          name: "",
          value: null,
        },
        peopleseven: {
          name: "",
          value: null,
        },
        peopleeight: {
          name: "",
          value: null,
        },
        peoplenine: {
          name: "",
          value: null,
        },
        peopleten: {
          name: "",
          value: null,
        },

        // 民办院校数组
        peopleArrNew: [],

        Frist: {},
        Second: {},
        Third: {},
      },
      getSchoolRegion: {
        dataList: [],
        firstObj: {
          name: "",
          value: null,
        },
        secondObj: {
          name: "",
          value: null,
        },
        thirdObj: {
          name: "",
          value: null,
        },
      },
      distribution: {
        // 本专业岗位需求行业分布情况
        dataList: [],
        Frist: {
          name: "",
          value: null,
        },
        Second: {
          name: "",
          value: null,
        },
        Third: {
          name: "",
          value: null,
        },
      },

      salaryposts: {
        dataList: [],
        Frist: {
          name: "",
          value: null,
        },
        colorList: [
          "#3B86FF",
          "#5697FF",
          "#3FBBFE",
          "#66CAFE",
          "#7F88FE",
          "#BBA8FF",
          "#CACEFE",
          "#A3FFF8",
          "#63D0FF",
          "#82DAFF",
          "#4FC9FC",
          "#8EF1FF",
          "#6DD0D8",
          "#9FD5FF",
          "#79C6F8",
          "#31D8F8",
          "#11CBFF",
          "#6ACFFF",
          "#64BFFF",
          "#5093FF",
        ],
      },
      discipline: {
        //本专业招聘单位分布情况
        dataList: [],
        Frist: {
          name: "",
          value: null,
        },
        Second: {
          name: "",
          value: null,
        },
        Third: {
          name: "",
          value: null,
        },
      },
      getProfession: {
        dataList: [],
        transverseData: [],
        Frist: {
          name: "",
          value: null,
        },
        Second: {
          name: "",
          value: null,
        },
        Third: {
          name: "",
          value: null,
        },
      },
      ranking: {
        // 本专业岗位需求排名(15名)
        transverseData: [],
        dataList: [],
        Frist: {
          name: "",
          value: null,
        },
        Second: {
          name: "",
          value: null,
        },
        Third: {
          name: "",
          value: null,
        },
      },
      posts: {
        // 本专业岗位薪酬排名
        transverseData: [],
        dataList: [],
        Frist: {
          name: "",
          value: null,
        },
        Second: {
          name: "",
          value: null,
        },
        Third: {
          name: "",
          value: null,
        },
      },
      // 本专业面向职业发展方向分布
      getDevelopment: {
        dataList: [],
        Frist: {
          name: "",
          value: null,
        },
        Second: {
          name: "",
          value: null,
        },
        Third: {
          name: "",
          value: null,
        },
        colorList: [
          "#3B86FF",
          "#5697FF",
          "#3FBBFE",
          "#66CAFE",
          "#A3FFF8",
          "#63D0FF",
          "#82DAFF",
          "#4FC9FC",
          "#8EF1FF",
          "#9FD5FF",
          "#79C6F8",
          "#31D8F8",
          "#11CBFF",
          "#6ACFFF",
          "#9FD5FF",
          "#79C6F8",
          "#6DD0D8",
          "#64BFFF",
          "#5093FF",
        ],
      },
      loading: "", //是否导出加载中
    };
  },
  created() {
    if (this.$route.query) {
      let token = this.$route.query.token;
      sessionStorage.setItem("lrmv2token", token);
      let zykid = this.$route.query.zykid;
      this.dataChange(zykid);
      this.$route.query.zykName = this.$route.query.zykName;
      this.header.zykname = this.$route.query.zykname;
      this.nowYearText = parseInt(this.$route.query.startDay.slice(0, 4));
      this.yearMonthText = this.nowYearText;
      if (
        this.$route.query.startDay.indexOf("01-01") !== -1 &&
        this.$route.query.endDay.indexOf("03-31") !== -1
      ) {
        this.yearMonthText += "年第1季度";
        this.nowQuarterText = 1;
        this.lastQuarterText = 4;
      } else if (
        this.$route.query.startDay.indexOf("04-01") !== -1 &&
        this.$route.query.endDay.indexOf("06-30") !== -1
      ) {
        this.yearMonthText += "年第2季度";
        this.nowQuarterText = 2;
        this.lastQuarterText = 1;
      } else if (
        this.$route.query.startDay.indexOf("07-01") !== -1 &&
        this.$route.query.endDay.indexOf("09-30") !== -1
      ) {
        this.yearMonthText += "年第3季度";
        this.nowQuarterText = 3;
        this.lastQuarterText = 2;
      } else if (
        this.$route.query.startDay.indexOf("10-01") !== -1 &&
        this.$route.query.endDay.indexOf("12-31") !== -1
      ) {
        this.yearMonthText += "年第4季度";
        this.nowQuarterText = 4;
        this.lastQuarterText = 3;
      }
    }
    setTimeout(() => {
      this.getas();
      this.essentialHandler();
      this.resourceLibraryDom(); // 当前资源库用户情况
      this.getUserCountUnitDom(); // 当前资源库建设单位注册用户情况
      this.typeDistributionDom();
      this.standardizationDom();
      this.behaviorTypesDom();
      this.resourcePoolDom();
      this.usersMonthDomAndMajorUser();
      this.bengeyueAndShanggeyue();

      // this.bengeyue()
      // this.usersMonthDom();
      this.resourcesMonthDom();
      this.materialMonthDom();
      this.coursesMonthDom();
      this.accessMonthDom();
      this.visitsMonthDom();
      this.userAccessMonthDom();
      this.getLrmv2MonthBehaviorUserCourseLog();

      this.getSchoolHandler();
      this.getSchoolRegionHandler();
      this.postsAcrossDom1();

      // setTimeout(() => {
      //   this.getCity()
      // }, 0)
      this.distributionDom();
      this.salarypostsDom();
      this.disciplineDom();
      this.getProfessionHandler();
      this.rankingDom();
      this.postsDom();
      this.getDevelopmentHandler();
      this.tearcherTop(); //   表1  教师访问量前十排名
      this.studentTop(); //    表2 学生访问量前十排名
    }, 1000);
  },
  watch: {
    completeNum(val) {
      console.log(val);
    },
  },
  methods: {
    // 切换专业
    dataChange(e) {
      this.$axios
        .post(this.$apiurls.major_switch, e, {
          loading: false,
        })
        .then((res) => {
          if (res.data) {
            sessionStorage.setItem("zykId", e);
            this.reload();
            this.completeNum = this.completeNum + 1;
          }
        });
    },

    reload() {
      //切换专业刷新视图层
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },

    // 导出pdf文件
    exportPdf() {
      const lableList = document.getElementsByClassName("page-box");
      let name = this.header.zykName.split("(");
      let newName = "";
      let oldName = "";
      let zykName = "";
      if (name.length > 1) {
        newName = name[0];
        oldName = name[1].replace(")", "");
        zykName = `${newName}（原专业名称：${oldName}）`;
      } else zykName = this.header.zykName;
      pageToPDF(
        `${this.header.zykNum}_${zykName}_季度报告`,
        this.$refs.pdfContent,
        lableList,
        true
      );
    },

    // 获取报告基本信息
    getas() {
      this.$axios
        .post(this.$apiurls.report_yaer_getZykInformationVo, {
          loading: false,
        })
        .then((res) => {
          this.header = res.data;
          this.allHostUnit = "主持院校" + "：" + this.header.allHostUnit.replaceAll(",", "，");
          this.completeNum = this.completeNum + 1;
        });
    },

    essentialHandler() {
      this.$axios
        .post(this.$apiurls.getProfessionalInfoForRedis, {
          loading: false,
        })
        .then((res) => {
          if (res.data) {
            this.essential.majorCode = res.data[0].majorCode;
            this.essential.majorName = res.data[0].majorName;
            this.essential.professionalFace = res.data[0].professionalFace;
            this.essential.trainingObjectives = res.data[0].trainingObjectives;
            this.essential.basicsCourse = res.data[0].basicsCourse;
            this.essential.coreCourse = res.data[0].coreCourse;
            this.essential.internship = res.data[0].internship;
            this.essential.professionalLevelBook = res.data[0].professionalLevelBook;
            this.essential.highProfessionUndergraduate = res.data[0].highProfessionUndergraduate;
            this.essential.ordinaryUndergraduate = res.data[0].ordinaryUndergraduate;

            this.list[0]["td1"].push(this.essential.majorCode);
            this.list[1]["td1"].push(this.essential.majorName);
            this.list[2]["td1"].push(this.essential.professionalFace);
            this.list[3]["td1"].push(this.essential.trainingObjectives);
            this.list[4]["td1"].push(this.essential.basicsCourse);
            this.list[5]["td1"].push(this.essential.coreCourse);
            this.list[6]["td1"].push(this.essential.internship);
            this.list[7]["td1"].push(this.essential.professionalLevelBook);
            this.list[8]["td1"].push(this.essential.highProfessionUndergraduate);
            this.list[9]["td1"].push(this.essential.ordinaryUndergraduate);
            this.completeNum = this.completeNum + 1;
          }
        });
    },

    // 图1 资源库注册用户类型分布总体情况
    resourceLibraryDom() {
      this.$axios
        .post(this.$apiurls.report_monthly_resourceLibrary, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            let arrList = [];
            arrList.push(
              {
                name: "教师",
                value: res.data.teacherNum,
              },
              {
                name: "学生",
                value: res.data.studentNum,
              },
              {
                name: "企业用户",
                value: res.data.enterpriseNum,
              },
              {
                name: "社会学习者",
                value: res.data.socialNum,
              }
            );
            this.resourceLibrary.total = res.data.total;
            this.resourceLibrary.teacherNum = res.data.teacherNum;
            this.resourceLibrary.studentNum = res.data.studentNum;
            this.resourceLibrary.enterpriseNum = res.data.enterpriseNum;
            this.resourceLibrary.socialNum = res.data.socialNum;
            this.resourceLibrary.dataList = arrList;
            this.completeNum = this.completeNum + 1;
          }
        });
    },

    //图2 当前资源库参建单位注册用户情况
    getUserCountUnitDom() {
      this.$axios
        .post(this.$apiurls.report_monthly_getUserCountUnit, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            var studentList = [];
            var teacherList = [];
            this.userCountUnit.cjteacherNum = res.data.teacherNum;
            this.userCountUnit.cjstudentNum = res.data.studentNum;
            this.userCountUnit.zcteacherNum = res.data.enterpriseNum;
            this.userCountUnit.zcstudentNum = res.data.socialNum;
            this.userCountUnit.teacherNum = res.data.teacherNum + res.data.enterpriseNum;
            this.userCountUnit.studentNum = res.data.studentNum + res.data.socialNum;

            teacherList.push(
              {
                name: "主持单位教师",
                value: res.data.enterpriseNum,
              },
              {
                name: "参建单位教师",
                value: res.data.teacherNum,
              }
            );

            studentList.push(
              {
                name: "主持单位学生",
                value: res.data.socialNum,
              },
              {
                name: "参建单位学生",
                value: res.data.studentNum,
              }
            );
            this.userCountUnit.studentList = studentList;
            this.userCountUnit.teacherList = teacherList;
            this.completeNum = this.completeNum + 1;
          }
        });
    },
    // 图3 资源库素材资源类型分布
    typeDistributionDom() {
      this.$axios
        .post(this.$apiurls.report_year_getStatResourceDataEntity, 1, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            var arrList = [];
            arrList.push(
              {
                name: "视频类",
                value: res.data.videoNum,
              },
              {
                name: "动画类",
                value: res.data.animationNum,
              },
              {
                name: "图形图像类",
                value: res.data.graphicImageNum,
              },
              {
                name: "虚拟仿真类",
                value: res.data.virtualSimulationNum,
              },
              {
                name: "文本类",
                value: res.data.textNum,
              },
              {
                name: "微课类",
                value: res.data.smallCourseNum,
              },
              {
                name: "音频类",
                value: res.data.shenyangNum,
              },
              {
                name: "ppt和富媒体等",
                value: res.data.pptNum + res.data.coursewareNum + res.data.mediaNum,
              },
              {
                name: "其他",
                value: res.data.otherNum,
              }
            );
            this.typeDistribution.spNumber = res.data.videoNum;
            this.typeDistribution.dhNumber = res.data.animationNum;
            this.typeDistribution.txtxNumber = res.data.graphicImageNum;
            this.typeDistribution.xnfzNumber = res.data.virtualSimulationNum;
            this.typeDistribution.wbNumber = res.data.textNum;
            this.typeDistribution.wkNumber = res.data.smallCourseNum;
            this.typeDistribution.ypNumber = res.data.shenyangNum;
            this.typeDistribution.kjNumber = res.data.coursewareNum;
            this.typeDistribution.pptNumber = res.data.pptNum;
            this.typeDistribution.fmtNumber = res.data.mediaNum;
            this.typeDistribution.qtNumber = res.data.otherNum;
            this.typeDistribution.total = res.data.total;
            this.typeDistribution.dataList = arrList;
            this.completeNum = this.completeNum + 1;
          }
        });
    },
    // 图4 该资源库标准化课程访问量排名
    standardizationDom() {
      this.$axios
        .post(this.$apiurls.report_monthly_standardization, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            var name = [];
            var value = [];
            for (let i = 0; i < res.data.lrmv2UserResourceCourseRankingLogEntities.length; i++) {
              name.push(res.data.lrmv2UserResourceCourseRankingLogEntities[i].name);
              value.push(res.data.lrmv2UserResourceCourseRankingLogEntities[i].num);
            }
            this.standardization.dataList = value;
            this.standardization.transverseData = name;
            this.standardization.courseBzNum = res.data.courseBzNum;
            this.completeNum = this.completeNum + 1;
          }
        });
    },

    // 图5 资源库用户行为类型分布
    behaviorTypesDom() {
      this.$axios
        .post(this.$apiurls.report_monthly_behaviorTypes, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            var arrList = [];
            arrList.push(
              {
                name: "课程模块",
                value: res.data.courseModule,
              },
              {
                name: "资源素材模块",
                value: res.data.resourceModule,
              },
              {
                name: "论坛模块",
                value: res.data.forumModule,
              },
              {
                name: "作业模块",
                value: res.data.taskModule,
              },
              {
                name: "考试模块",
                value: res.data.examinationModule,
              },
              {
                name: "其他模块",
                value: res.data.otherModule,
              }
            );
            this.behaviorTypes.loginModule = res.data.loginModule;
            this.behaviorTypes.courseModule = res.data.courseModule;
            this.behaviorTypes.resourceModule = res.data.resourceModule;
            this.behaviorTypes.forumModule = res.data.forumModule;
            this.behaviorTypes.taskModule = res.data.taskModule;
            this.behaviorTypes.examinationModule = res.data.examinationModule;
            this.behaviorTypes.otherModule = res.data.otherModule;
            this.behaviorTypes.total = res.data.total;
            this.behaviorTypes.dataList = arrList;
            this.completeNum = this.completeNum + 1;
          }
        });
    },
    // 图6 资源库无活动数据情况
    resourcePoolDom() {
      this.$axios
        .post(this.$apiurls.report_monthly_resourcePool, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.resourcePool = res.data;
            this.waterDrop.teacher = parseFloat(
              (this.resourcePool.countTeacher / this.resourcePool.realTeacher) * 100
                ? Math.round(
                    (this.resourcePool.countTeacher / this.resourcePool.realTeacher) * 100
                  ).toFixed(2)
                : 0
            );
            this.waterDrop.student = parseFloat(
              (this.resourcePool.countStudent / this.resourcePool.realStudent) * 100
                ? Math.round(
                    (this.resourcePool.countStudent / this.resourcePool.realStudent) * 100
                  ).toFixed(2)
                : 0
            );
            this.waterDrop.resource = parseFloat(
              (this.resourcePool.countResource / this.typeDistribution.total) * 100
                ? Math.round(
                    (this.resourcePool.countResource / this.typeDistribution.total) * 100
                  ).toFixed(2)
                : 0
            );

            this.waterDrop.teacherNum = parseFloat(
              (this.resourcePool.countTeacher / this.resourcePool.realTeacher) * 100
                ? ((this.resourcePool.countTeacher / this.resourcePool.realTeacher) * 100).toFixed(
                    2
                  )
                : 0
            );
            this.waterDrop.studentNum = parseFloat(
              (this.resourcePool.countStudent / this.resourcePool.realStudent) * 100
                ? ((this.resourcePool.countStudent / this.resourcePool.realStudent) * 100).toFixed(
                    2
                  )
                : 0
            );
            this.waterDrop.resourceNum = parseFloat(
              (this.resourcePool.countResource / this.typeDistribution.total) * 100
                ? ((this.resourcePool.countResource / this.typeDistribution.total) * 100).toFixed(2)
                : 0
            );
            this.completeNum = this.completeNum + 1;
            // this.getLrmv2MonthUserCourseResource();
          }
        });
    },
    //图7、图8 本月用户新增情况、主持院校与参建院校新增占比情况 同步请求
    usersMonthDomAndMajorUser() {
      //同步发送请求
      //图7 本月用户新增情况
      var p1 = new Promise((resolve, reject) => {
        this.$axios
          .post(
            this.$apiurls.quarterly_monthly_getQuarterZykAdd,
            {
              type: 1,
              year: this.nowYearText,
              quarter: this.nowQuarterText,
            },
            {
              loading: false,
            }
          )
          .then((res) => {
            this.completeNum = this.completeNum + 1;
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
      //图8 主持院校与参建院校新增占比情况
      var p2 = new Promise((resolve, reject) => {
        this.$axios
          .post(
            this.$apiurls.quarterly_monthly_getQuarterMajorUser,
            {
              year: this.nowYearText,
              quarter: this.nowQuarterText,
            },
            {
              loading: false,
            }
          )
          .then((res) => {
            this.completeNum = this.completeNum + 1;
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });

      Promise.all([p1, p2]).then((res) => {
        //图7 本月用户新增情况
        var transverse = [];
        var teacherDate = [];
        var studentDate = [];
        var enterpriseDate = [];
        var socialDate = [];

        var teacherNum = 0;
        var studentNum = 0;
        var enterpriseNum = 0;
        var socialNum = 0;
        for (let i = 0; i < res[0].teacher.length; i++) {
          transverse.push(res[0].teacher[i].date);
          teacherDate.push(res[0].teacher[i].num);
          teacherNum += parseFloat(res[0].teacher[i].num);
        }
        for (let i = 0; i < res[0].student.length; i++) {
          studentDate.push(res[0].student[i].num);
          studentNum += parseFloat(res[0].student[i].num);
        }
        for (let i = 0; i < res[0].enterprise.length; i++) {
          enterpriseDate.push(res[0].enterprise[i].num);
          enterpriseNum += parseFloat(res[0].enterprise[i].num);
        }
        for (let i = 0; i < res[0].social.length; i++) {
          socialDate.push(res[0].social[i].num);
          socialNum += parseFloat(res[0].social[i].num);
        }

        this.usersMonth.dataList = [teacherDate, studentDate, enterpriseDate, socialDate];
        this.usersMonth.transverseData = transverse;
        this.usersMonth.legendList = ["教师", "学生", "企业用户", "社会学习者"];
        this.usersMonth.teacherNum = teacherNum;
        this.usersMonth.studentNum = studentNum;
        this.usersMonth.enterpriseNum = enterpriseNum;
        this.usersMonth.socialNum = socialNum;
        this.usersMonth.total = teacherNum + studentNum + enterpriseNum + socialNum;

        //图8 主持院校与参建院校新增占比情况
        this.majorUser.teacher = res[1].teacher ? res[1].teacher : 0;
        this.majorUser.student = res[1].student ? res[1].student : 0;
        this.majorUser.cjteacher = res[1].cjteacher ? res[1].cjteacher : 0;
        this.majorUser.cjstudent = res[1].cjstudent ? res[1].cjstudent : 0;

        this.waterDrop.majorteacher = parseFloat(
          this.usersMonth.teacherNum
            ? Math.round((this.majorUser.teacher / this.usersMonth.teacherNum) * 100).toFixed(2)
            : 0
        );
        this.waterDrop.majorstudent = parseFloat(
          this.usersMonth.studentNum
            ? Math.round((this.majorUser.student / this.usersMonth.studentNum) * 100).toFixed(2)
            : 0
        );
        this.waterDrop.unitteacher = parseFloat(
          this.usersMonth.teacherNum
            ? Math.round((this.majorUser.cjteacher / this.usersMonth.teacherNum) * 100).toFixed(2)
            : 0
        );
        this.waterDrop.unitstudent = parseFloat(
          this.usersMonth.studentNum
            ? Math.round((this.majorUser.cjstudent / this.usersMonth.studentNum) * 100).toFixed(2)
            : 0
        );

        this.waterDrop.majorteacherNum = parseFloat(
          this.usersMonth.teacherNum
            ? ((this.majorUser.teacher / this.usersMonth.teacherNum) * 100).toFixed(2)
            : 0
        );
        this.waterDrop.majorstudentNum = parseFloat(
          this.usersMonth.studentNum
            ? ((this.majorUser.student / this.usersMonth.studentNum) * 100).toFixed(2)
            : 0
        );
        this.waterDrop.unitteacherNum = parseFloat(
          this.usersMonth.teacherNum
            ? ((this.majorUser.cjteacher / this.usersMonth.teacherNum) * 100).toFixed(2)
            : 0
        );
        this.waterDrop.unitstudentNum = parseFloat(
          this.usersMonth.studentNum
            ? ((this.majorUser.cjstudent / this.usersMonth.studentNum) * 100).toFixed(2)
            : 0
        );
      });
    },

    // 图9 本季度和上季度资源库各类型素材资源新增情况，同步请求
    bengeyueAndShanggeyue() {
      //同步发送请求
      //本季度
      var p1 = new Promise((resolve, reject) => {
        this.$axios
          .post(
            this.$apiurls.quarterly_monthly_getLrmv2QuarterUserCourseResource,
            {
              year: this.nowYearText,
              quarter: this.nowQuarterText,
            },
            {
              loading: false,
            }
          )
          .then((res) => {
            this.completeNum = this.completeNum + 1;
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
      //上季度
      var p2 = new Promise((resolve, reject) => {
        this.$axios
          .post(
            this.$apiurls.quarterly_monthly_getLrmv2QuarterUserCourseResource,
            {
              year: this.nowYearText - 1,
              quarter: this.lastQuarterText,
            },
            {
              loading: false,
            }
          )
          .then((res) => {
            this.completeNum = this.completeNum + 1;
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });

      Promise.all([p1, p2]).then((res) => {
        this.ben.dataList = res[0];
        this.ben.noAccessStudent = res[0].noAccessStudent;
        this.ben.noAccessTeacher = res[0].noAccessTeacher;
        this.ben.noAccessResource = res[0].noAccessResource;
        this.ben.noAccessResourceList = parseFloat(
          res[0].noAccessResource > 0 && this.typeDistribution.total > 0
            ? ((res[0].noAccessResource / res[0].resourceTotal) * 100).toFixed(2)
            : 0
        );

        this.LastMoth.dataList = res[1];
        this.LastMoth.wufagnwennumber = this.ben.noAccessResource - res[1].noAccessResource;
        this.LastMoth.noAccessStudent = res[1].noAccessStudent;
        this.LastMoth.noAccessTeacher = res[1].noAccessTeacher;

        this.LastMoth.noAccessResource = res[1].noAccessResource;
        this.LastMoth.noAccessResourceList = parseFloat(
          res[1].noAccessResource > 0 && this.typeDistribution.total > 0
            ? ((res[1].noAccessResource / res[1].resourceTotal) * 100).toFixed(2)
            : 0
        );
      });
    },

    // 图9 资源库无活动师生数据变化情况,图11 资源库无访问资源较上季度变化情况,图12 本月课程新增情况
    getLrmv2MonthUserCourseResource() {
      this.$axios
        .post(this.$apiurls.report_monthly_resourcePool, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.lastMonth = res.data;
            this.verticalBar.dataList = [
              [this.ben.noAccessTeacher, this.ben.noAccessStudent],
              [this.LastMoth.noAccessTeacher, this.LastMoth.noAccessStudent],
            ];
            this.verticalBar.transverseData = ["无活动教师", "无活动学生"];
            this.verticalBar.legendList = ["本季度", "上季度"];

            // 上季度无访问资源占比
            this.waterDrop.lastresource = (
              (this.LastMoth.noAccessResource / this.typeDistribution.total) *
              100
            ).toFixed(2)
              ? Math.round(
                  (this.LastMoth.noAccessResource / this.typeDistribution.total) * 100
                ).toFixed(2)
              : 0;
            let num = parseFloat(this.waterDrop.lastresource);
            this.waterDrop.lastresource = num;
            this.completeNum = this.completeNum + 1;
          }
        });
    },
    // 图10 资源库各类型素材资源新增情况
    resourcesMonthDom() {
      this.$axios
        .post(
          this.$apiurls.quarterly_monthly_getQuarterZykAdd,
          {
            type: 2,
            year: this.nowYearText,
            quarter: this.nowQuarterText,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res) {
            var arrList = [];
            var number = 0;
            var total = 0;
            let legendList = [];
            for (let i = 0; i <= res.data.length - 1; i++) {
              var detailed_type = "";
              switch (res.data[i].detailed_type) {
                case 1:
                  detailed_type = "视频";
                  arrList.push({
                    name: detailed_type,
                    value: res.data[i].num,
                  });
                  legendList.push(detailed_type);
                  break;
                case 2:
                  detailed_type = "动画";
                  arrList.push({
                    name: detailed_type,
                    value: res.data[i].num,
                  });
                  legendList.push(detailed_type);
                  break;
                case 3:
                  detailed_type = "图形图像";
                  arrList.push({
                    name: detailed_type,
                    value: res.data[i].num,
                  });
                  legendList.push(detailed_type);
                  break;
                case 4:
                  detailed_type = "虚拟仿真";
                  arrList.push({
                    name: detailed_type,
                    value: res.data[i].num,
                  });
                  legendList.push(detailed_type);
                  break;
                case 5:
                  detailed_type = "文本";
                  arrList.push({
                    name: detailed_type,
                    value: res.data[i].num,
                  });
                  legendList.push(detailed_type);
                  break;
                case 6:
                  detailed_type = "微课";
                  arrList.push({
                    name: detailed_type,
                    value: res.data[i].num,
                  });
                  legendList.push(detailed_type);
                  break;
                case 7:
                  detailed_type = "音频";
                  arrList.push({
                    name: detailed_type,
                    value: res.data[i].num,
                  });
                  legendList.push(detailed_type);
                  break;
                case 8:
                  number += res.data[i].num;
                  break;
                case 9:
                  number += res.data[i].num;
                  break;
                case 10:
                  number += res.data[i].num;
                  break;
                case 11:
                  detailed_type = "其他";
                  arrList.push({
                    name: detailed_type,
                    value: res.data[i].num,
                  });
                  legendList.push(detailed_type);
                  break;
              }
              total += parseFloat(res.data[i].num);
            }
            if (number > 0) {
              arrList.push({
                name: "ppt和富媒体等",
                value: number,
              });
              legendList.push("ppt和富媒体等");
            }

            this.resourcesMonth.dataList = arrList;
            this.resourcesMonth.total = total;
            this.completeNum = this.completeNum + 1;
          }
        });
    },
    materialMonthDom() {
      this.$axios
        .post(
          this.$apiurls.getQuarterResourceAdd,
          { startDate: this.$route.query.startDay, endDate: this.$route.query.endDay },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res) {
            this.materialMonth.dataList = res.data.ResourceNum;
            this.materialMonth.transverseData = res.data.time;
            this.materialMonth.legendList = ["新增资源"];
            this.completeNum = this.completeNum + 1;
          }
        });
    },
    // 图12 本月课程新增情况
    coursesMonthDom() {
      this.$axios
        .post(
          this.$apiurls.getQuarterCourseAdd,
          { startDate: this.$route.query.startDay, endDate: this.$route.query.endDay },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res) {
            this.coursesMonth.dataList = [res.data.standardCourse, res.data.personalityCourse];
            this.coursesMonth.legendList = ["标准化课程", "个性化课程"];
            this.coursesMonth.transverseData = res.data.time;
            this.coursesMonth.standardNum = res.data.standardCourse.reduce((a, b) => a + b, 0);
            this.coursesMonth.personalityNum = res.data.personalityCourse.reduce(
              (a, b) => a + b,
              0
            );
            this.completeNum = this.completeNum + 1;
          }
        });
    },
    // 图14 本月资源访问情况
    accessMonthDom() {
      this.$axios
        .post(
          this.$apiurls.quarterly_monthly_getQuarterZykAdd,
          { type: 4, year: this.nowYearText, quarter: this.nowQuarterText },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res) {
            let arrList = [];
            var transverse = [];
            var total = 0;

            for (let i = 0; i < res.data.length; i++) {
              arrList.push(res.data[i].num);
              transverse.push(res.data[i].date);
              total += parseFloat(res.data[i].num);
            }
            this.accessMonth.dataList = arrList;
            this.accessMonth.transverseData = transverse;
            this.accessMonth.legendList = ["资源访问"];
            this.accessMonth.total = total;
            this.completeNum = this.completeNum + 1;
          }
        });
    },
    // 图15 本月课程访问情况
    visitsMonthDom() {
      this.$axios
        .post(
          this.$apiurls.quarterly_monthly_getQuarterZykAdd,
          { type: 5, year: this.nowYearText, quarter: this.nowQuarterText },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res) {
            var transverse = [];
            var arrList = [];
            var total = 0;
            for (let i = 0; i < res.data.length; i++) {
              transverse.push(res.data[i].date);
              arrList.push(res.data[i].num);
              total += parseFloat(res.data[i].num);
            }
            this.visitsMonth.dataList = arrList;
            this.visitsMonth.transverseData = transverse;
            this.visitsMonth.legendList = ["课程访问"];
            this.visitsMonth.total = total;
            this.completeNum = this.completeNum + 1;
          }
        });
    },
    // 图16 本月用户访问情况
    userAccessMonthDom() {
      this.$axios
        .post(
          this.$apiurls.quarterly_monthly_getQuarterZykAdd,
          { type: 6, year: this.nowYearText, quarter: this.nowQuarterText },
          {
            loading: false,
          }
        )
        .then((res) => {
          let teacherTotal = 0;
          let enterpriseTotal = 0;
          let studentTotal = 0;
          let socialTotal = 0;
          let teacherNumArray = [];
          let enterpriseNumArray = [];
          let studentNumArray = [];
          let socialNumArray = [];
          var total = 0;
          let transverse = [];
          if (res) {
            for (let i = 0; i < res.data.teacherAction.length; i++) {
              teacherTotal += parseFloat(res.data.teacherAction[i].num);
              transverse.push(res.data.teacherAction[i].date);
              teacherNumArray.push(res.data.teacherAction[i].num);
            }
            for (let i = 0; i < res.data.studentAction.length; i++) {
              studentTotal += parseFloat(res.data.studentAction[i].num);
              enterpriseNumArray.push(res.data.studentAction[i].num);
            }
            for (let i = 0; i < res.data.enterpriseAction.length; i++) {
              enterpriseTotal += parseFloat(res.data.enterpriseAction[i].num);
              studentNumArray.push(res.data.enterpriseAction[i].num);
            }
            for (let i = 0; i < res.data.socialAction.length; i++) {
              socialTotal += parseFloat(res.data.socialAction[i].num);
              socialNumArray.push(res.data.socialAction[i].num);
            }
            let total = teacherTotal + studentTotal + enterpriseTotal + socialTotal;
            this.userAccessMonth.dataList = [
              teacherNumArray,
              enterpriseNumArray,
              studentNumArray,
              socialNumArray,
            ];
            this.userAccessMonth.transverseData = transverse;
            this.userAccessMonth.legendList = [
              "教师行为",
              "学生行为",
              "企业用户行为",
              "社会学习者行为",
            ];
            this.userAccessMonth.total = total;
            this.completeNum = this.completeNum + 1;
          }
        });
    },
    // 图17 本月用户访问时间段分布
    getLrmv2MonthBehaviorUserCourseLog() {
      this.$axios
        .post(this.$apiurls.getLrmv2QuarterBehaviorUserCourseLog, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            var arrList = [];
            var total = 0;
            for (let i = 0; i < res.data.length; i++) {
              arrList.push([
                res.data[i].behaviorOne,
                res.data[i].behaviorTwo,
                res.data[i].behaviorThree,
                res.data[i].behaviorFour,
                res.data[i].behaviorFive,
                res.data[i].behaviorSix,
                res.data[i].behaviorSeven,
                res.data[i].behaviorEight,
              ]);
              total +=
                parseFloat(res.data[i].behaviorOne) +
                parseFloat(res.data[i].behaviorTwo) +
                parseFloat(res.data[i].behaviorThree) +
                parseFloat(res.data[i].behaviorFour) +
                parseFloat(res.data[i].behaviorFive) +
                parseFloat(res.data[i].behaviorSix) +
                parseFloat(res.data[i].behaviorSeven) +
                parseFloat(res.data[i].behaviorEight);
            }
            this.behaviorUser.dataList = arrList;
            this.behaviorUser.transverseData = [
              "00：00—03：00",
              "03：00—06：00",
              "06：00—09：00",
              "09：00—12：00",
              "12：00—15：00",
              "15：00—18：00",
              "18：00—21：00",
              "21：00—00：00",
            ];
            this.behaviorUser.legendList = [
              "教师行为",
              "学生行为",
              "企业用户行为",
              "社会学习者行为",
            ];
            this.behaviorUser.total = total;
            this.completeNum = this.completeNum + 1;
          }
        });
    },
    // 访问量较多的教师（前十）
    tearcherTop() {
      this.$axios
        .post(
          this.$apiurls.getQuarterTeacherTotalVisitRank,
          {},
          {
            loading: false,
          }
        )
        .then((res) => {
          this.tearcherList.dataList = res.data;
          this.completeNum = this.completeNum + 1;
        });
    },
    // 访问量较多的学生（前十）
    studentTop() {
      this.$axios
        .post(
          this.$apiurls.getQuarterStudentTotalVisitRank,
          {},
          {
            loading: false,
          }
        )
        .then((res) => {
          this.studentList.dataList = res.data;
          this.completeNum = this.completeNum + 1;
        });
    },
    // 3.1 本专业开设院校办学性质分布
    getSchoolHandler() {
      this.$axios
        .post(
          this.$apiurls.marketAnalysis_getSchoolNatureChart,
          {
            loading: false,
          },
          { timeout: 3 * 60 * 1000 }
        )
        .then((res) => {
          if (res.data && res.data.data) {
            // 公办院校
            for (let i = 0; i < res.data.data.value[0].length; i++) {
              this.getSchool.stateArr.push({
                name: res.data.data.name[i],
                value: res.data.data.value[0][i],
              });
            }
            // 民办院校
            for (let i = 0; i < res.data.data.value[1].length; i++) {
              this.getSchool.peopleArr.push({
                value: res.data.data.value[1][i],
                name: res.data.data.name[i],
              });
            }

            function Sort(a, b) {
              return b.value - a.value;
            }

            // 民办院校排序
            this.getSchool.stateArr.sort(Sort);
            let newArr2 = this.getSchool.stateArr;
            // 排除不等于 0  的数组
            this.getSchool.publicSchoolRankArr = newArr2.filter((item) => item.value - 0 != 0);
            // 当长度大于3的时候取第三名的数值为最大值，并且筛选过滤
            if (this.getSchool.publicSchoolRankArr.length > 3) {
              // 设置一个最大值
              var Max = this.getSchool.publicSchoolRankArr[2].value - 0;
              this.getSchool.publicSchoolRankArr = this.getSchool.publicSchoolRankArr.filter(
                (item) => item.value - 0 >= Max
              );
            }

            if (this.getSchool.publicSchoolRankArr.length == 0) {
              this.getSchool.stateFrist = [];
            } else if (this.getSchool.publicSchoolRankArr.length == 1) {
              this.getSchool.stateFrist = this.getSchool.publicSchoolRankArr[0];
            } else if (this.getSchool.publicSchoolRankArr.length == 2) {
              this.getSchool.stateFrist = this.getSchool.publicSchoolRankArr[0];
              this.getSchool.stateSecond = this.getSchool.publicSchoolRankArr[1];
            } else if (this.getSchool.publicSchoolRankArr.length == 3) {
              this.getSchool.stateFrist = this.getSchool.publicSchoolRankArr[0];
              this.getSchool.stateSecond = this.getSchool.publicSchoolRankArr[1];
              this.getSchool.stateThird = this.getSchool.publicSchoolRankArr[2];
            } else if (this.getSchool.publicSchoolRankArr.length == 4) {
              this.getSchool.stateFrist = this.getSchool.publicSchoolRankArr[0];
              this.getSchool.stateSecond = this.getSchool.publicSchoolRankArr[1];
              this.getSchool.stateThird = this.getSchool.publicSchoolRankArr[2];
              this.getSchool.stateFourth = this.getSchool.publicSchoolRankArr[3];
            } else if (this.getSchool.publicSchoolRankArr.length == 5) {
              this.getSchool.stateFrist = this.getSchool.publicSchoolRankArr[0];
              this.getSchool.stateSecond = this.getSchool.publicSchoolRankArr[1];
              this.getSchool.stateThird = this.getSchool.publicSchoolRankArr[2];
              this.getSchool.stateFourth = this.getSchool.publicSchoolRankArr[3];
              this.getSchool.statefive = this.getSchool.publicSchoolRankArr[4];
            } else if (this.getSchool.publicSchoolRankArr.length == 6) {
              this.getSchool.stateFrist = this.getSchool.publicSchoolRankArr[0];
              this.getSchool.stateSecond = this.getSchool.publicSchoolRankArr[1];
              this.getSchool.stateThird = this.getSchool.publicSchoolRankArr[2];
              this.getSchool.stateFourth = this.getSchool.publicSchoolRankArr[3];
              this.getSchool.statefive = this.getSchool.publicSchoolRankArr[4];
              this.getSchool.statesix = this.getSchool.publicSchoolRankArr[5];
            } else if (this.getSchool.publicSchoolRankArr.length == 7) {
              this.getSchool.stateFrist = this.getSchool.publicSchoolRankArr[0];
              this.getSchool.stateSecond = this.getSchool.publicSchoolRankArr[1];
              this.getSchool.stateThird = this.getSchool.publicSchoolRankArr[2];
              this.getSchool.stateFourth = this.getSchool.publicSchoolRankArr[3];
              this.getSchool.statefive = this.getSchool.publicSchoolRankArr[4];
              this.getSchool.statesix = this.getSchool.publicSchoolRankArr[5];
              this.getSchool.stateseven = this.getSchool.publicSchoolRankArr[6];
            } else if (this.getSchool.publicSchoolRankArr.length == 8) {
              this.getSchool.stateFrist = this.getSchool.publicSchoolRankArr[0];
              this.getSchool.stateSecond = this.getSchool.publicSchoolRankArr[1];
              this.getSchool.stateThird = this.getSchool.publicSchoolRankArr[2];
              this.getSchool.stateFourth = this.getSchool.publicSchoolRankArr[3];
              this.getSchool.statefive = this.getSchool.publicSchoolRankArr[4];
              this.getSchool.statesix = this.getSchool.publicSchoolRankArr[5];
              this.getSchool.stateseven = this.getSchool.publicSchoolRankArr[6];
              this.getSchool.stateeight = this.getSchool.publicSchoolRankArr[7];
            } else if (this.getSchool.publicSchoolRankArr.length == 9) {
              this.getSchool.stateFrist = this.getSchool.publicSchoolRankArr[0];
              this.getSchool.stateSecond = this.getSchool.publicSchoolRankArr[1];
              this.getSchool.stateThird = this.getSchool.publicSchoolRankArr[2];
              this.getSchool.stateFourth = this.getSchool.publicSchoolRankArr[3];
              this.getSchool.statefive = this.getSchool.publicSchoolRankArr[4];
              this.getSchool.statesix = this.getSchool.publicSchoolRankArr[5];
              this.getSchool.stateseven = this.getSchool.publicSchoolRankArr[6];
              this.getSchool.stateeight = this.getSchool.publicSchoolRankArr[7];
              this.getSchool.statenine = this.getSchool.publicSchoolRankArr[8];
            } else if (this.getSchool.publicSchoolRankArr.length == 10) {
              this.getSchool.stateFrist = this.getSchool.publicSchoolRankArr[0];
              this.getSchool.stateSecond = this.getSchool.publicSchoolRankArr[1];
              this.getSchool.stateThird = this.getSchool.publicSchoolRankArr[2];
              this.getSchool.stateFourth = this.getSchool.publicSchoolRankArr[3];
              this.getSchool.statefive = this.getSchool.publicSchoolRankArr[4];
              this.getSchool.statesix = this.getSchool.publicSchoolRankArr[5];
              this.getSchool.stateseven = this.getSchool.publicSchoolRankArr[6];
              this.getSchool.stateeight = this.getSchool.publicSchoolRankArr[7];
              this.getSchool.statenine = this.getSchool.publicSchoolRankArr[8];
              this.getSchool.stateten = this.getSchool.publicSchoolRankArr[9];
            }

            // 民办院校排序
            this.getSchool.peopleArr.sort(Sort);
            let newArr1 = this.getSchool.peopleArr;
            // 排除不等于 0  的数组
            this.getSchool.privateSchoolRankArr = newArr1.filter((item) => item.value - 0 != 0);
            // 当长度大于3的时候取第三名的数值为最大值，并且筛选过滤
            if (this.getSchool.privateSchoolRankArr.length > 3) {
              // 设置一个最大值
              var Max = this.getSchool.privateSchoolRankArr[2].value - 0;
              this.getSchool.privateSchoolRankArr = this.getSchool.privateSchoolRankArr.filter(
                (item) => item.value - 0 >= Max
              );
            }

            if (this.getSchool.privateSchoolRankArr.length == 0) {
              this.getSchool.peopleFrist = [];
            } else if (this.getSchool.privateSchoolRankArr.length == 1) {
              this.getSchool.peopleFrist = this.getSchool.privateSchoolRankArr[0];
            } else if (this.getSchool.privateSchoolRankArr.length == 2) {
              this.getSchool.peopleFrist = this.getSchool.privateSchoolRankArr[0];
              this.getSchool.peopleSecond = this.getSchool.privateSchoolRankArr[1];
            } else if (this.getSchool.privateSchoolRankArr.length == 3) {
              this.getSchool.peopleFrist = this.getSchool.privateSchoolRankArr[0];
              this.getSchool.peopleSecond = this.getSchool.privateSchoolRankArr[1];
              this.getSchool.peopleThird = this.getSchool.privateSchoolRankArr[2];
            } else if (this.getSchool.privateSchoolRankArr.length == 4) {
              this.getSchool.peopleFrist = this.getSchool.privateSchoolRankArr[0];
              this.getSchool.peopleSecond = this.getSchool.privateSchoolRankArr[1];
              this.getSchool.peopleThird = this.getSchool.privateSchoolRankArr[2];
              this.getSchool.peopleFourth = this.getSchool.privateSchoolRankArr[3];
            } else if (this.getSchool.privateSchoolRankArr.length == 5) {
              this.getSchool.peopleFrist = this.getSchool.privateSchoolRankArr[0];
              this.getSchool.peopleSecond = this.getSchool.privateSchoolRankArr[1];
              this.getSchool.peopleThird = this.getSchool.privateSchoolRankArr[2];
              this.getSchool.peopleFourth = this.getSchool.privateSchoolRankArr[3];
              this.getSchool.peoplefive = this.getSchool.privateSchoolRankArr[4];
            } else if (this.getSchool.privateSchoolRankArr.length == 6) {
              this.getSchool.peopleFrist = this.getSchool.privateSchoolRankArr[0];
              this.getSchool.peopleSecond = this.getSchool.privateSchoolRankArr[1];
              this.getSchool.peopleThird = this.getSchool.privateSchoolRankArr[2];
              this.getSchool.peopleFourth = this.getSchool.privateSchoolRankArr[3];
              this.getSchool.peoplefive = this.getSchool.privateSchoolRankArr[4];
              this.getSchool.peoplesix = this.getSchool.privateSchoolRankArr[5];
            } else if (this.getSchool.privateSchoolRankArr.length == 7) {
              this.getSchool.peopleFrist = this.getSchool.privateSchoolRankArr[0];
              this.getSchool.peopleSecond = this.getSchool.privateSchoolRankArr[1];
              this.getSchool.peopleThird = this.getSchool.privateSchoolRankArr[2];
              this.getSchool.peopleFourth = this.getSchool.privateSchoolRankArr[3];
              this.getSchool.peoplefive = this.getSchool.privateSchoolRankArr[4];
              this.getSchool.peoplesix = this.getSchool.privateSchoolRankArr[5];
              this.getSchool.peopleseven = this.getSchool.privateSchoolRankArr[6];
            } else if (this.getSchool.privateSchoolRankArr.length == 8) {
              this.getSchool.peopleFrist = this.getSchool.privateSchoolRankArr[0];
              this.getSchool.peopleSecond = this.getSchool.privateSchoolRankArr[1];
              this.getSchool.peopleThird = this.getSchool.privateSchoolRankArr[2];
              this.getSchool.peopleFourth = this.getSchool.privateSchoolRankArr[3];
              this.getSchool.peoplefive = this.getSchool.privateSchoolRankArr[4];
              this.getSchool.peopleseven = this.getSchool.privateSchoolRankArr[5];
              this.getSchool.peopleseven = this.getSchool.privateSchoolRankArr[6];
              this.getSchool.peopleeight = this.getSchool.privateSchoolRankArr[7];
            } else if (this.getSchool.privateSchoolRankArr.length == 9) {
              this.getSchool.peopleFrist = this.getSchool.privateSchoolRankArr[0];
              this.getSchool.peopleSecond = this.getSchool.privateSchoolRankArr[1];
              this.getSchool.peopleThird = this.getSchool.privateSchoolRankArr[2];
              this.getSchool.peopleFourth = this.getSchool.privateSchoolRankArr[3];
              this.getSchool.peoplefive = this.getSchool.privateSchoolRankArr[4];
              this.getSchool.peoplesix = this.getSchool.privateSchoolRankArr[5];
              this.getSchool.peopleseven = this.getSchool.privateSchoolRankArr[6];
              this.getSchool.peopleeight = this.getSchool.privateSchoolRankArr[7];
              this.getSchool.peoplenine = this.getSchool.privateSchoolRankArr[8];
            } else if (this.getSchool.privateSchoolRankArr.length == 10) {
              this.getSchool.peopleFrist = this.getSchool.privateSchoolRankArr[0];
              this.getSchool.peopleSecond = this.getSchool.privateSchoolRankArr[1];
              this.getSchool.peopleThird = this.getSchool.privateSchoolRankArr[2];
              this.getSchool.peopleFourth = this.getSchool.privateSchoolRankArr[3];
              this.getSchool.peoplefive = this.getSchool.privateSchoolRankArr[4];
              this.getSchool.peoplesix = this.getSchool.privateSchoolRankArr[5];
              this.getSchool.peopleseven = this.getSchool.privateSchoolRankArr[6];
              this.getSchool.peopleeight = this.getSchool.privateSchoolRankArr[7];
              this.getSchool.peoplenine = this.getSchool.privateSchoolRankArr[8];
              this.getSchool.peopleten = this.getSchool.privateSchoolRankArr[9];
            }
            if (res) {
              this.getSchool.dataList = res.data.data.value;
              this.getSchool.transverseData = res.data.data.name;
            }
            this.completeNum = this.completeNum + 1;
          }
        });
    },
    // 3.2 本专业开设院校地域分布
    getSchoolRegionHandler() {
      this.$axios
        .post(
          this.$apiurls.marketAnalysis_getSchoolRegion,
          {
            loading: false,
          },
          { timeout: 3 * 60 * 1000 }
        )
        .then((res) => {
          if (res.data && res.data.data && res.data.data.name && res.data.data.name.length > 0) {
            for (let i = 0; i < res.data.data.name.length; i++) {
              this.getSchoolRegion.dataList.push({
                name: res.data.data.name[i],
                value: res.data.data.value[i],
              });
              this.getSchoolRegion.firstObj = this.getSchoolRegion.dataList[0];
              this.getSchoolRegion.secondObj = this.getSchoolRegion.dataList[1];
              this.getSchoolRegion.thirdObj = this.getSchoolRegion.dataList[2];
            }
            this.completeNum = this.completeNum + 1;
          }
        });
    },
    // 3.3 全国区域本专业岗位需求分布情况 地图
    postsAcrossDom1() {
      let p1 = new Promise((resolve, reject) => {
        this.$axios
          .post(this.$apiurls.marketAnalysis_getCityPostOrSchoolNum, 1, {
            loading: false,
          })
          .then((res) => {
            this.completeNum = this.completeNum + 1;
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });

      let p2 = new Promise((resolve, reject) => {
        this.$axios
          .post(this.$apiurls.marketAnalysis_getCityPostOrSchoolNum, 2, {
            loading: false,
          })
          .then((res) => {
            this.completeNum = this.completeNum + 1;
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });

      Promise.all([p1, p2]).then((res) => {
        if (res[0].data && res[1].data) {
          if (res[0].data.length > 0) {
            this.map.arr1 = res[0].data;
            this.map.Frist1 = this.map.arr1[0];
            this.map.Second1 = this.map.arr1[1];
            this.map.Third1 = this.map.arr1[2];
            this.map.Fourth1 = this.map.arr1[3];
            this.map.fifth1 = this.map.arr1[4];
          }

          if (res[0].data.length > 0) {
            this.map.arr2 = res[1].data;
            this.map.Frist = this.map.arr2[0];
            this.map.Second = this.map.arr2[1];
            this.map.Third = this.map.arr2[2];
            this.map.Fourth = this.map.arr2[3];
            this.map.fifth = this.map.arr2[4];
          }

          this.map.dataList.push(res[0].data, res[1].data);
        }
      });
    },
    // 3.4 本专业岗位需求行业分布情况
    distributionDom() {
      this.$axios
        .post(this.$apiurls.marketAnalysis_getPostNum, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.distribution.dataList = res.data.data.map((item) => {
              let name = item.name;
              let value = item.num;
              return {
                name,
                value,
              };
            });
            this.distribution.Frist = this.distribution.dataList[0];
            this.distribution.Second = this.distribution.dataList[1];
            this.distribution.Third = this.distribution.dataList[2];
            this.completeNum = this.completeNum + 1;
          }
        });
    },

    // 3.5 本专业市场需求地域分布
    salarypostsDom() {
      this.$axios
        .post(this.$apiurls.marketAnalysis_getEnterpriseRegion, {
          loading: false,
        })
        .then((res) => {
          if (res.data && res.data.data && res.data.data.list && res.data.data.list.length > 0) {
            res.data.data.list.forEach((item) => {
              this.salaryposts.dataList.push({
                name: item.name,
                value: item.num,
              });
            });
            this.salaryposts.Frist = this.salaryposts.dataList[0];
          }
          this.completeNum = this.completeNum + 1;
        });
    },

    disciplineDom() {
      this.$axios
        .post(this.$apiurls.marketAnalysis_getProfessionEnterpriseTypeNum, {
          loading: false,
        })
        .then((res) => {
          if (res.data) {
            if (res.data.data.list.length > 0) {
              this.discipline.dataList = res.data.data.list.map((item) => {
                let name = item.name;
                let value = item.num;
                return {
                  name,
                  value,
                };
              });
              function Sort(a, b) {
                return b.value - a.value;
              }

              this.discipline.dataList.sort(Sort);
              this.discipline.Frist = this.discipline.dataList[0];
              this.discipline.Second = this.discipline.dataList[1];
              this.discipline.Third = this.discipline.dataList[2];
            }
          }
          this.completeNum = this.completeNum + 1;
        });
    },

    // 3.7 本专业企业需求行业分布情况
    getProfessionHandler() {
      this.$axios
        .post(this.$apiurls.marketAnalysis_getProfessionEnterpriseNum, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.getProfession.Frist = res.data.data[0];
            this.getProfession.Second = res.data.data[1];
            this.getProfession.Third = res.data.data[2];

            res.data.data.forEach((item) => {
              this.getProfession.dataList.push(item.num);
              this.getProfession.transverseData.push(item.name);
            });
          }
          this.completeNum = this.completeNum + 1;
        });
    },
    // 3.8 本专业岗位需求排名(15名)
    rankingDom() {
      this.$axios
        .post(this.$apiurls.marketAnalysis_getProfessionHotJob, 4, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            let datas = res.data.data.list;
            datas.forEach((item) => {
              this.ranking.transverseData.push(item.name);
              this.ranking.dataList.push(item.num);
            });
            this.ranking.Frist = datas[0];
            this.ranking.Second = datas[1];
            this.ranking.Third = datas[2];
          }
          this.completeNum = this.completeNum + 1;
        });
    },
    // 第二层
    // 3.9 本专业岗位薪酬排名
    postsDom() {
      this.$axios
        .post(this.$apiurls.marketAnalysis_getProfessionHotJob, 5, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            let datas = res.data.data.list;
            datas.forEach((item) => {
              this.posts.transverseData.push(item.name);
              this.posts.dataList.push(item.num);
            });
            this.posts.Frist = datas[0];
            this.posts.Second = datas[1];
            this.posts.Third = datas[2];
          }
          this.completeNum = this.completeNum + 1;
        });
    },

    // 3.10 本专业面向职业发展方向分布
    getDevelopmentHandler() {
      this.$axios
        .post(this.$apiurls.marketAnalysis_getDevelopmentDirection, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.getDevelopment.dataList = res.data.data.map((item) => {
              let name = item.name;
              let value = item.value;
              return {
                name,
                value,
              };
            });
            if (this.getDevelopment.dataList.length > 2) {
              this.getDevelopment.Frist = this.getDevelopment.dataList[0];
              this.getDevelopment.Second = this.getDevelopment.dataList[1];
              this.getDevelopment.Third = this.getDevelopment.dataList[2];
            } else if (this.getDevelopment.dataList.length > 1) {
              this.getDevelopment.Frist = this.getDevelopment.dataList[0];
              this.getDevelopment.Second = this.getDevelopment.dataList[1];
            } else if (this.getDevelopment.dataList.length > 0) {
              this.getDevelopment.Frist = this.getDevelopment.dataList[0];
            }
          }
          this.completeNum = this.completeNum + 1;
        });
    },

    dataHandler(data) {
      return data > 100000000
        ? (data / 100000000).toFixed(2) + "亿"
        : data > 10000
        ? (data / 10000).toFixed(2) + "万"
        : data;
    },

    teacherFormat() {
      return `${this.waterDrop.teacherNum}%`;
    },
    studentFormat() {
      return `${this.waterDrop.studentNum}%`;
    },
    resourceFormat() {
      return `${this.ben.noAccessResourceList}%`;
    },
    lastresourceFormat() {
      return `${this.LastMoth.noAccessResourceList}%`;
    },
    majorteacherFormat() {
      return `${this.waterDrop.majorteacherNum}%`;
    },
    majorstudentFormat() {
      return `${this.waterDrop.majorstudentNum}%`;
    },
    unitteacherFormat() {
      return `${this.waterDrop.unitteacherNum}%`;
    },
    unitstudentFormat() {
      return `${this.waterDrop.unitstudentNum}%`;
    },
  },
};
</script>

<style scoped>
* {
  padding: 0rem;
  margin: 0rem;
}

.analysisReport {
  width: 100%;
  background: #fff;
}

h1,
h2,
h3,
h4,
h5,
p {
  margin: 0rem;
  padding: 0rem;
}

.analysisReport_box {
  /*width: 70%;*/
  /* height: 1847.625rem; */
}

.analysisReport_box h2,
.analysisReport h2 {
  font-size: 3.4375rem;
  color: #fff;
}

.header_titles {
  display: flex;
  justify-content: center;
  flex-flow: column;
  color: #000;
  text-align: center;
  position: relative;
  font-size: 2.5rem;
}

.header_titles h1,
.analysisReport_box h1,
.analysisReport h1 {
  text-align: center;
  font-size: 3.75rem;
  font-weight: bold;
  color: #fff;
  line-height: 4.375rem;
  /* margin-top: 3.125rem; */
}

.header_titles .monthly {
  font-size: 2.5rem;
  font-weight: 400;
  color: #1d244e;
  line-height: 1.875rem;
  margin-top: 0.375rem;
}

.bgc {
  position: relative;
  background: linear-gradient(
    rgba(63, 117, 203) 0%,
    rgba(74, 130, 205) 50%,
    rgba(91, 154, 225) 100%
  );
  height: 35.9375rem;
  text-align: center;
}

.bgc h2 {
  margin-top: 1.25rem;
}

.bgc p {
  width: 100%;
  height: 0.625rem;
  background: #fff;
  position: absolute;
  bottom: 1.25rem;
  /* margin-top: 10.625rem; */
}

.bgc .bgcText {
  width: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.bgcText h1 {
  line-height: 5.625rem;
  padding: 0rem 1.25rem;
  box-sizing: border-box;
}

.number_time2 {
  margin: 40px 0 60px 0;
}

.number_time2 div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #707f9d;
  font-size: 1.8125rem;
}

.number_time2 .shchool,
.number_time2 .time {
  font-size: 1.75rem;
}

.number_time2 p {
  width: 100%;
  height: 1px;
  background: #707f9d;
  margin-top: 8px;
}

.number_time2 p:last-child {
  opacity: 0.5;
  margin-top: 4px;
}

.division {
  position: relative;
  clear: both;
  text-align: center;
  font-weight: bold;
  font-size: 44px;
  color: #1d244e;
}

.lineheight {
  position: relative;
  text-align: left;
}

.chart_box .lineheight p {
  line-height: 4.375rem;
}

.chart_box .lineheight h6 {
  line-height: 2.1875rem;
}

.chart_box h3 {
  font-weight: 700;
  font-size: 2.8125rem;
  color: #1d244e;
  line-height: 2.5rem;
  /* margin-bottom: 2.1875rem; */
  margin-top: 3.125rem;
}

.chart_box h4 {
  font-weight: 700;
  font-size: 42px;
  color: #1d244e;
  line-height: 100px;
}

.chart_box h5 {
  font-size: 40px;
  margin-bottom: 35px;
  color: #1d244e;
}

.chart_box h6 {
  font-weight: 700;
  font-size: 2.8125rem;
  color: #1d244e;
  margin-bottom: 2.1875rem;
  margin-top: 3.125rem;
}

.chart_box p {
  font-size: 2.1875rem;
  text-indent: 2em;
  line-height: 4.375rem;
  color: #707f9d;
}

.chart_box .echartsHeight,
.layout,
.speed {
  width: 90%;
  /* height: calc(100vw / 1080 * 300); */
  height: 28rem;
  margin: 0.625rem auto 0rem;
}

.speed {
  width: 100%;
  height: auto;
}

.speed > div {
  width: 80%;
  font-size: 1.5625rem;
  color: #707f9d;
  line-height: 1.75rem;
  margin: 1.25rem auto;
}

.speed .el-col {
  margin-bottom: 0.9375rem;
}

.speed .el-col div {
  height: 2.5rem;
  display: flex;
  align-items: center;
}

.speed .el-col-6 {
  white-space: nowrap;
}

.chart_box .chart_name {
  text-align: center;
  font-size: 30px;
  color: #707f9d;
  clear: both;
  margin-top: 20px;
}

.chart_box .notes {
  margin: 2.1875rem;
  line-height: 3.125rem;
  font-size: 1.875rem;
  color: #707f9d;
}

/* 布局 */
.layout {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.export {
  width: 88px;
  height: 32px;
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 1;
}

.center {
  text-align: center;
}

.divorced {
  margin-top: 2.5rem;
}

::v-deep .el-progress-bar__innerText {
  color: #000;
  font-size: 1.5625rem;
}

.right {
  float: right;
  margin-right: 1.25rem;
  font-size: 2rem;
}

.lineheight .th_box .th {
  width: 21.875rem;
  height: 2.8125rem;
  line-height: 2.8125rem;
  color: #707f9d;
  font-size: 1.625rem;
  /* background: rgba(73, 187, 233); */
}

.left {
  float: left;
}

.rights {
  position: absolute;
  background: red;
  top: 0rem;
  right: 0rem;
}

.course {
  text-align: center;
  margin: 0rem 0.625rem;
}

.course tr {
  height: 2.8125rem;
  line-height: 2.8125rem;
  color: #707f9d;
  font-size: 1.625rem;
}

.course tr:nth-child(2n) {
  background: rgba(11, 201, 212, 0.2);
  color: #566178;
}

.course tr:nth-child(2n-1) {
  background: rgba(73, 187, 233);

  color: #566178;
}

.course tr:first-child {
  background: rgb(88, 136, 248);
  color: #fff;
}

::v-deep .el-progress-bar__innerText {
  color: #000;
  font-size: 1.5625rem;
}
</style>

<style scoped>
.table_box {
  font-size: 2.1875rem;
  display: -webkit-box;
  width: 100%;
}

.table_box .table {
  margin: 0 auto;
  width: 100%;
}

.table_box .table .tr {
  display: flex;
  width: 100%;
}

.table_box .table .tr .td:nth-child(1) {
  width: 20rem;
  line-height: 4.375rem;
  text-align: right;
  /* border: .0625rem solid rgba(63, 63, 209); */
  /* border-right: 0rem solid rgba(63, 63, 209); */

  /* margin: .0625rem 0rem; */
  /* background: rgba(63, 63, 209); */
  color: black;
}

.table_box .table .tr .td:nth-child(2) {
  /* width: 81.875rem; */
  line-height: 4.375rem;
  color: #566178;
  flex: 1;
  /* border: .0625rem solid rgba(63, 63, 209); */
}
</style>
<style lang="scss" scoped>
.page-box {
  // padding: 7% 0;
  // height: 2740px;
  width: 85%;
  padding-top: 5%;
  margin: 0rem auto;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  // border: 1px solid red;

  .m-top150 {
    margin-top: 150px;
  }

  .biaoge {
    width: 95%;
    margin: 25px auto;

    .course {
      text-align: center;
      margin: 0px 10px;

      tr {
        height: 42px;
        color: #707f9d;
        font-size: 22px;

        &:nth-child(2n) {
          background: #fff;
          color: #566178;
        }

        &:nth-child(2n-1) {
          background: #7ed2ff;
          color: #566178;
        }
      }
    }
  }
}

.flex-box {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  & > div {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
}
</style>
